// @ts-nocheck
/* eslint-disable */
import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  MonitorPlay,
  UserPlus,
  Settings,
  Plus,
  Trash2,
  Volume2,
  VolumeX,
  Star,
  Clock,
  ArrowRight,
  Volume1,
  RefreshCw,
  FileText,
  Search,
  UserCog,
  Layers,
  DoorOpen,
  Sliders,
  CheckCircle,
  AlertTriangle,
  Building2,
  ShieldPlus,
  Image as ImageIcon,
  MapPin,
  Calendar,
  Maximize,
  Minimize,
  Type,
  Lock,
  PieChart,
  Printer,
  Check,
  UserX,
  Video,
  Users,
  Briefcase,
  Contact,
  UserCircle,
  Play,
  Edit2,
  CornerUpLeft,
  FileEdit,
  CalendarDays,
  CalendarPlus,
  ChevronRight,
  PauseCircle,
  PlayCircle,
  ListOrdered,
  Loader2,
} from "lucide-react";
import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInAnonymously,
  signInWithCustomToken,
  onAuthStateChanged,
} from "firebase/auth";
import {
  getFirestore,
  collection,
  onSnapshot,
  doc,
  setDoc,
  writeBatch,
  deleteDoc,
  query,
  where,
  getDocs,
  runTransaction,
} from "firebase/firestore";

// --- CONFIGURACIÓN INICIAL POR DEFECTO ---
const defaultSedes = [{ id: "1", name: "Sede Principal", floors: 2 }];
const defaultEps = [
  { id: "1", name: "Aliansalud" },
  { id: "2", name: "Allianz" },
  { id: "3", name: "Anas Wayuu" },
  { id: "4", name: "Asmet Salud" },
  { id: "5", name: "Capital Salud" },
  { id: "6", name: "Colsanitas" },
  { id: "7", name: "Compensar" },
  { id: "8", name: "Coomeva" },
  { id: "9", name: "EPS Sanitas" },
  { id: "10", name: "EPS Sura" },
  { id: "11", name: "Famisanar" },
  { id: "12", name: "Nueva EPS" },
  { id: "13", name: "Salud Total" },
  { id: "14", name: "Savia Salud" },
];
const defaultServices = [
  {
    id: "1",
    name: "Oncología Clínica",
    prefix: "ONC",
    sedeId: "1",
    floor: "1",
  },
  { id: "2", name: "Laboratorio", prefix: "LAB", sedeId: "1", floor: "2" },
];
const defaultRooms = [
  { id: "1", name: "Consultorio 1", sedeId: "1", serviceId: "1" },
  { id: "2", name: "Sala de Muestras", sedeId: "1", serviceId: "2" },
];

// UTILIDAD: Fecha Local Segura
const getLocalDateString = () => {
  const date = new Date();
  const tzOffset = date.getTimezoneOffset() * 60000;
  // CORRECCIÓN VERCEL: Se usa getTime() para asegurar que la operación sea número - número
  return new Date(date.getTime() - tzOffset).toISOString().split("T")[0];
};

export default function App() {
  // --- ESTADOS GLOBALES ---
  const [activeView, setActiveView] = useState("menu");
  const [sedes, setSedes] = useState([]);
  const [epsList, setEpsList] = useState([]);
  const [services, setServices] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [counters, setCounters] = useState({});
  const [staffList, setStaffList] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [globalSettings, setGlobalSettings] = useState({
    volume: 1,
    logoUrl: null,
    welcomeTitle: "",
    welcomeMessage: "",
    adminPin: "",
    staffPin: "",
    orientadorPin: "",
    agendaPin: "",
    mediaUrl: "",
    tvMarquee:
      "Bienvenido. Recuerde preparar su documento de identidad. Atención prioritaria disponible.",
    masterPassword: "admin",
  });

  // Estados de Seguridad y Notificaciones
  const [pendingView, setPendingView] = useState(null);
  const [pinInput, setPinInput] = useState("");
  const [pinError, setPinError] = useState(false);
  const [showRecovery, setShowRecovery] = useState(false);
  const [recoveryInput, setRecoveryInput] = useState("");
  const [toast, setToast] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // --- INYECCIÓN DE TAILWIND CSS ---
  useEffect(() => {
    if (!document.getElementById("tailwind-cdn")) {
      const script = document.createElement("script");
      script.id = "tailwind-cdn";
      script.src = "https://cdn.tailwindcss.com";
      document.head.appendChild(script);
    }
  }, []);

  // Firebase State
  const [user, setUser] = useState(null);
  const [db, setDb] = useState(null);
  const [isReady, setIsReady] = useState(false);
  const [configError, setConfigError] = useState(false);
  const [authError, setAuthError] = useState("");

  const appId =
    typeof window !== "undefined" && window.__app_id
      ? window.__app_id
      : "digiturno-oncologico";

  const showToast = (message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 4000);
  };

  // --- INICIALIZACIÓN FIREBASE ---
  useEffect(() => {
    let unsubscribeAuth;
    const setupFirebase = async () => {
      try {
        // ============================================================================
        // CONFIGURACIÓN DE PRODUCCIÓN - ONCOLLANO
        // ============================================================================
        const firebaseConfigReal = {
          apiKey: "AIzaSyBeCDSbHCudSy5aeul3PuRErv88e902fJU",
          authDomain: "digiturno-oncollano.firebaseapp.com",
          projectId: "digiturno-oncollano",
          storageBucket: "digiturno-oncollano.firebasestorage.app",
          messagingSenderId: "667838240238",
          appId: "1:667838240238:web:7407bd62117c3e49c62aff",
        };

        let finalConfig = firebaseConfigReal;

        if (
          typeof window !== "undefined" &&
          window.__firebase_config &&
          window.__firebase_config !== "{}"
        ) {
          try {
            finalConfig = JSON.parse(window.__firebase_config);
          } catch (e) {}
        }

        if (!finalConfig.apiKey || finalConfig.apiKey.includes("TU_API_KEY")) {
          setConfigError(true);
          return;
        }

        const app = initializeApp(finalConfig);
        const auth = getAuth(app);
        const firestoreDb = getFirestore(app);
        setDb(firestoreDb);

        let currentAuthToken = null;
        if (typeof window !== "undefined" && window.__initial_auth_token) {
          currentAuthToken = window.__initial_auth_token;
        }

        try {
          if (currentAuthToken) {
            await signInWithCustomToken(auth, currentAuthToken);
          } else {
            await signInAnonymously(auth);
          }
        } catch (authErr) {
          console.error("Auth error:", authErr);
          setAuthError(
            "Tus llaves de Firebase son inválidas, faltan permisos o estás en entorno bloqueado."
          );
          return;
        }

        unsubscribeAuth = onAuthStateChanged(auth, setUser);
      } catch (error) {
        console.error("Error inicializando Firebase:", error);
        setAuthError(
          "Error conectando a la base de datos. Revisa la configuración."
        );
      }
    };
    setupFirebase();
    return () => {
      if (unsubscribeAuth) unsubscribeAuth();
    };
  }, []);

  // --- SUSCRIPCIÓN A DATOS ---
  useEffect(() => {
    if (!user || !db) return;
    let unsubs = [];

    const loadData = async () => {
      try {
        const basePath = `artifacts/${appId}/public/data`;

        const subscribeAndInit = (collectionName, stateSetter, defaultData) => {
          return onSnapshot(
            collection(db, `${basePath}/${collectionName}`),
            (snapshot) => {
              const loaded = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
              }));
              stateSetter(loaded.length > 0 ? loaded : defaultData);
              if (loaded.length === 0 && defaultData) {
                const batch = writeBatch(db);
                defaultData.forEach((item) =>
                  batch.set(
                    doc(db, `${basePath}/${collectionName}`, item.id),
                    item
                  )
                );
                batch.commit();
              }
            },
            (error) => {
              console.error(`Error al cargar ${collectionName}`);
            }
          );
        };

        unsubs.push(subscribeAndInit("sedes", setSedes, defaultSedes));
        unsubs.push(subscribeAndInit("eps", setEpsList, defaultEps));
        unsubs.push(subscribeAndInit("services", setServices, defaultServices));
        unsubs.push(subscribeAndInit("rooms", setRooms, defaultRooms));
        unsubs.push(subscribeAndInit("staff", setStaffList, []));

        const todayLocalStr = getLocalDateString();

        const ticketsQuery = query(
          collection(db, `${basePath}/tickets`),
          where("dateString", "==", todayLocalStr)
        );
        unsubs.push(
          onSnapshot(
            ticketsQuery,
            (snapshot) => {
              setTickets(
                snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
              );
            },
            (error) => console.error("Error al cargar turnos vivos")
          )
        );

        const apptsQuery = query(
          collection(db, `${basePath}/appointments`),
          where("date", ">=", todayLocalStr)
        );
        unsubs.push(
          onSnapshot(apptsQuery, (snapshot) => {
            setAppointments(
              snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
            );
          })
        );

        unsubs.push(
          onSnapshot(collection(db, `${basePath}/counters`), (snapshot) => {
            const counts = {};
            snapshot.docs.forEach((doc) => {
              counts[doc.id] = doc.data().count;
            });
            setCounters(counts);
          })
        );

        unsubs.push(
          onSnapshot(doc(db, `${basePath}/settings`, "global"), (docSnap) => {
            if (docSnap.exists())
              setGlobalSettings((prev) => ({ ...prev, ...docSnap.data() }));
            else
              setDoc(doc(db, `${basePath}/settings`, "global"), {
                volume: 1,
                logoUrl: null,
                adminPin: "",
                staffPin: "",
                orientadorPin: "",
                agendaPin: "",
                tvMarquee: "Bienvenido...",
                masterPassword: "admin",
              });
          })
        );

        setIsReady(true);
      } catch (error) {
        showToast("Error crítico al conectar", "error");
      }
    };
    loadData();
    return () => {
      unsubs.forEach((unsub) => unsub());
    };
  }, [user, db, appId]);

  // --- MÉTODOS DE BASE DE DATOS Y TRANSACCIONES COMPARTIDAS ---
  const saveTicket = async (newTicket) => {
    if (!user || !db) return;
    try {
      await setDoc(
        doc(db, `artifacts/${appId}/public/data/tickets`, newTicket.id),
        newTicket
      );
    } catch (e) {
      showToast("Error al guardar turno", "error");
    }
  };

  const updateTicketStatus = async (ticketId, updates) => {
    if (!user || !db) return;
    try {
      await setDoc(
        doc(db, `artifacts/${appId}/public/data/tickets`, ticketId),
        updates,
        { merge: true }
      );
    } catch (e) {
      showToast("Error al actualizar", "error");
    }
  };

  const updateCounter = async (serviceId, count) => {
    if (!user || !db) return;
    try {
      await setDoc(
        doc(db, `artifacts/${appId}/public/data/counters`, serviceId),
        { count }
      );
    } catch (e) {}
  };

  const addEntityToDb = async (collectionName, entity) => {
    if (!user || !db) return;
    try {
      await setDoc(
        doc(db, `artifacts/${appId}/public/data/${collectionName}`, entity.id),
        entity
      );
      showToast("Registro exitoso");
    } catch (e) {
      showToast(`Error guardando datos`, "error");
    }
  };

  const deleteEntityFromDb = async (collectionName, entityId) => {
    if (!user || !db) return;
    try {
      await deleteDoc(
        doc(db, `artifacts/${appId}/public/data/${collectionName}`, entityId)
      );
      showToast("Eliminado con éxito");
    } catch (e) {
      showToast(`Error eliminando datos`, "error");
    }
  };

  const updateGlobalSettings = async (updates) => {
    if (!user || !db) return;
    try {
      await setDoc(
        doc(db, `artifacts/${appId}/public/data/settings`, "global"),
        updates,
        { merge: true }
      );
      showToast("Configuración guardada");
    } catch (e) {
      showToast("Error guardando configuración", "error");
    }
  };

  const updateAppointmentStatus = async (appIdToUpdate, updates) => {
    if (!user || !db) return;
    try {
      await setDoc(
        doc(db, `artifacts/${appId}/public/data/appointments`, appIdToUpdate),
        updates,
        { merge: true }
      );
    } catch (e) {
      showToast("Error actualizando cita", "error");
    }
  };

  // --- LÓGICA DE SEGURIDAD ---
  const handleNavigate = (view) => {
    let requiredPin = "";
    if (view === "admin") requiredPin = globalSettings.adminPin;
    if (view === "staff") requiredPin = globalSettings.staffPin;
    if (view === "orientador") requiredPin = globalSettings.orientadorPin;
    if (view === "agenda") requiredPin = globalSettings.agendaPin;

    setIsMobileMenuOpen(false);

    if (requiredPin && requiredPin.trim() !== "") {
      setPendingView(view);
      setPinInput("");
      setPinError(false);
      setShowRecovery(false);
      setRecoveryInput("");
    } else {
      setActiveView(view);
    }
  };

  const verifyPin = (e) => {
    e.preventDefault();
    let requiredPin = "";
    if (pendingView === "admin") requiredPin = globalSettings.adminPin;
    if (pendingView === "staff") requiredPin = globalSettings.staffPin;
    if (pendingView === "orientador")
      requiredPin = globalSettings.orientadorPin;
    if (pendingView === "agenda") requiredPin = globalSettings.agendaPin;

    if (pinInput === requiredPin) {
      setActiveView(pendingView);
      setPendingView(null);
    } else {
      setPinError(true);
      setPinInput("");
    }
  };

  const verifyRecovery = (e) => {
    e.preventDefault();
    const masterPass = globalSettings.masterPassword || "admin";
    if (recoveryInput === masterPass) {
      setActiveView(pendingView);
      setPendingView(null);
      showToast("Acceso maestro concedido", "success");
    } else {
      setPinError(true);
      setRecoveryInput("");
      showToast("Palabra incorrecta", "error");
    }
  };

  const Navigation = () => (
    <div className="bg-slate-800 text-white p-3 shadow-md z-50 relative print:hidden">
      <div className="flex justify-between items-center max-w-7xl mx-auto">
        <div
          className="flex items-center gap-2 cursor-pointer bg-white rounded p-1 hover:bg-slate-100 transition-colors"
          onClick={() => handleNavigate("menu")}
        >
          {globalSettings.logoUrl ? (
            <img
              src={globalSettings.logoUrl}
              alt="Logo"
              className="h-8 md:h-10 object-contain max-w-[150px] md:max-w-[200px]"
            />
          ) : (
            <div className="h-8 md:h-10 px-4 flex items-center font-bold text-slate-800 text-sm md:text-base">
              Mi Clínica
            </div>
          )}
        </div>

        {/* Menú Desktop */}
        <div className="hidden lg:flex gap-2 flex-wrap justify-end">
          <button
            onClick={() => handleNavigate("kiosk")}
            className={`px-3 py-1.5 rounded transition-colors text-sm font-medium ${
              activeView === "kiosk"
                ? "bg-teal-600 shadow"
                : "hover:bg-slate-700"
            }`}
          >
            Kiosco
          </button>
          <button
            onClick={() => handleNavigate("display")}
            className={`px-3 py-1.5 rounded transition-colors text-sm font-medium ${
              activeView === "display"
                ? "bg-teal-600 shadow"
                : "hover:bg-slate-700"
            }`}
          >
            TV
          </button>
          <button
            onClick={() => handleNavigate("orientador")}
            className={`px-3 py-1.5 rounded transition-colors text-sm font-medium flex items-center gap-1 ${
              activeView === "orientador"
                ? "bg-amber-600 shadow"
                : "hover:bg-slate-700"
            }`}
          >
            {globalSettings.orientadorPin && <Lock size={14} />} Orientador
          </button>
          <button
            onClick={() => handleNavigate("agenda")}
            className={`px-3 py-1.5 rounded transition-colors text-sm font-medium flex items-center gap-1 ${
              activeView === "agenda"
                ? "bg-emerald-600 shadow"
                : "hover:bg-slate-700"
            }`}
          >
            {globalSettings.agendaPin && <Lock size={14} />} Citas
          </button>
          <button
            onClick={() => handleNavigate("staff")}
            className={`px-3 py-1.5 rounded transition-colors text-sm font-medium flex items-center gap-1 ${
              activeView === "staff"
                ? "bg-indigo-600 shadow"
                : "hover:bg-slate-700"
            }`}
          >
            {globalSettings.staffPin && <Lock size={14} />} Atención
          </button>
          <button
            onClick={() => handleNavigate("admin")}
            className={`px-3 py-1.5 rounded transition-colors text-sm font-medium flex items-center gap-1 ${
              activeView === "admin"
                ? "bg-slate-600 shadow"
                : "hover:bg-slate-700"
            }`}
          >
            {globalSettings.adminPin && <Lock size={14} />} Admin
          </button>
        </div>

        {/* Botón Menú Móvil */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="lg:hidden p-2 rounded bg-slate-700 hover:bg-slate-600"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>

      {/* Menú Desplegable Móvil */}
      {isMobileMenuOpen && (
        <div className="lg:hidden flex flex-col gap-2 pt-4 pb-2 border-t border-slate-700 mt-3 animate-fade-in">
          <button
            onClick={() => handleNavigate("kiosk")}
            className="w-full text-left px-4 py-3 rounded hover:bg-slate-700"
          >
            Kiosco
          </button>
          <button
            onClick={() => handleNavigate("display")}
            className="w-full text-left px-4 py-3 rounded hover:bg-slate-700"
          >
            Pantalla TV
          </button>
          <button
            onClick={() => handleNavigate("orientador")}
            className="w-full text-left px-4 py-3 rounded hover:bg-slate-700 flex items-center gap-2"
          >
            {globalSettings.orientadorPin && <Lock size={14} />} Orientador
          </button>
          <button
            onClick={() => handleNavigate("agenda")}
            className="w-full text-left px-4 py-3 rounded hover:bg-slate-700 flex items-center gap-2"
          >
            {globalSettings.agendaPin && <Lock size={14} />} Citas
          </button>
          <button
            onClick={() => handleNavigate("staff")}
            className="w-full text-left px-4 py-3 rounded hover:bg-slate-700 flex items-center gap-2"
          >
            {globalSettings.staffPin && <Lock size={14} />} Atención
          </button>
          <button
            onClick={() => handleNavigate("admin")}
            className="w-full text-left px-4 py-3 rounded hover:bg-slate-700 flex items-center gap-2"
          >
            {globalSettings.adminPin && <Lock size={14} />} Admin
          </button>
        </div>
      )}
    </div>
  );

  // --- PANTALLAS DE ERROR ANTI-CARGA INFINITA ---
  if (configError) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 p-6 text-center font-sans">
        <AlertTriangle
          size={80}
          className="text-amber-500 mb-6 drop-shadow-md"
        />
        <h1 className="text-2xl md:text-3xl font-black text-slate-800 mb-4">
          Faltan tus Llaves de Firebase
        </h1>
        <p className="text-slate-600 text-lg max-w-2xl mb-4 leading-relaxed">
          Asegúrate de tener tus llaves de Firebase bien configuradas.
        </p>
      </div>
    );
  }

  if (authError) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 p-6 text-center font-sans">
        <UserX size={80} className="text-red-500 mb-6 drop-shadow-md" />
        <h1 className="text-2xl md:text-3xl font-black text-slate-800 mb-4">
          Acceso Denegado a la Base de Datos
        </h1>
        <div className="bg-red-50 border-2 border-red-200 text-red-700 text-lg p-6 rounded-2xl max-w-xl mb-6 shadow-md font-medium">
          {authError}
        </div>
        <p className="text-slate-500 font-medium max-w-lg">
          Asegúrate de habilitar el método de inicio de sesión "Anónimo" en
          Firebase.
        </p>
      </div>
    );
  }

  if (!isReady)
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-4 text-xl md:text-2xl font-bold text-teal-600 animate-pulse">
          <Loader2 size={48} className="animate-spin" /> Cargando Sistema...
        </div>
      </div>
    );

  return (
    <div className="min-h-screen bg-slate-100 flex flex-col font-sans">
      {toast && (
        <div
          className={`fixed top-5 left-1/2 transform -translate-x-1/2 z-[9999] px-4 md:px-6 py-2 md:py-3 rounded-full font-bold shadow-2xl flex items-center gap-2 text-white animate-fade-in text-sm md:text-base w-[90%] md:w-auto text-center justify-center ${
            toast.type === "error" ? "bg-red-600" : "bg-slate-800"
          }`}
        >
          {toast.type === "error" ? (
            <AlertTriangle size={20} className="shrink-0" />
          ) : (
            <CheckCircle size={20} className="shrink-0" />
          )}{" "}
          {toast.message}
        </div>
      )}

      {pendingView && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/80 backdrop-blur-sm p-4 print:hidden">
          <div className="bg-white p-6 md:p-8 rounded-3xl shadow-2xl max-w-sm w-full animate-pop-in border-t-8 border-slate-800">
            <div className="flex justify-center mb-4">
              <div className="bg-slate-100 p-4 rounded-full">
                <Lock size={32} className="text-slate-700" />
              </div>
            </div>
            <h2 className="text-xl md:text-2xl font-black text-center text-slate-800 mb-2">
              {showRecovery ? "Recuperar Acceso" : "Acceso Restringido"}
            </h2>
            <p className="text-center text-slate-500 mb-6 text-sm">
              {showRecovery
                ? "Ingrese la palabra maestra para acceder."
                : "Ingrese el PIN de seguridad."}
            </p>
            {!showRecovery ? (
              <form onSubmit={verifyPin} className="space-y-4">
                <input
                  type="password"
                  value={pinInput}
                  onChange={(e) => setPinInput(e.target.value)}
                  className={`w-full text-center text-3xl tracking-widest p-4 border-2 rounded-xl outline-none transition-colors ${
                    pinError
                      ? "border-red-500 bg-red-50 text-red-700"
                      : "border-slate-300 focus:border-slate-800"
                  }`}
                  placeholder="••••"
                  autoFocus
                  required
                />
                {pinError && (
                  <p className="text-red-500 text-xs font-bold text-center animate-pulse">
                    PIN INCORRECTO
                  </p>
                )}
                <div className="flex flex-col sm:flex-row gap-3 pt-2">
                  <button
                    type="button"
                    onClick={() => {
                      setPendingView(null);
                      setPinError(false);
                    }}
                    className="w-full py-3 bg-slate-100 text-slate-600 font-bold rounded-xl hover:bg-slate-200"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className="w-full py-3 bg-slate-800 text-white font-bold rounded-xl hover:bg-slate-900 shadow-lg"
                  >
                    Entrar
                  </button>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    setShowRecovery(true);
                    setPinError(false);
                  }}
                  className="w-full text-center text-xs text-slate-400 hover:text-slate-600 mt-4 underline underline-offset-2"
                >
                  ¿Olvidó el PIN?
                </button>
              </form>
            ) : (
              <form onSubmit={verifyRecovery} className="space-y-4">
                <input
                  type="password"
                  value={recoveryInput}
                  onChange={(e) => setRecoveryInput(e.target.value)}
                  className={`w-full text-center text-lg p-4 border-2 rounded-xl outline-none transition-colors ${
                    pinError
                      ? "border-red-500 bg-red-50 text-red-700"
                      : "border-slate-300 focus:border-slate-800"
                  }`}
                  placeholder="Palabra Maestra"
                  autoFocus
                  required
                />
                <div className="flex flex-col sm:flex-row gap-3 pt-2">
                  <button
                    type="button"
                    onClick={() => {
                      setShowRecovery(false);
                      setPinError(false);
                      setRecoveryInput("");
                    }}
                    className="w-full py-3 bg-slate-100 text-slate-600 font-bold rounded-xl hover:bg-slate-200"
                  >
                    Atrás
                  </button>
                  <button
                    type="submit"
                    className="w-full py-3 bg-slate-800 text-white font-bold rounded-xl hover:bg-slate-900 shadow-lg"
                  >
                    Verificar
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}

      {activeView !== "menu" && <Navigation />}

      <div className="flex-1 relative overflow-hidden flex flex-col">
        {activeView === "menu" && (
          <div className="flex-1 bg-slate-50 flex flex-col relative overflow-y-auto min-h-screen">
            <div className="absolute top-0 left-0 w-full h-64 md:h-80 bg-teal-600 rounded-b-[50px] md:rounded-b-[100px] z-0 shadow-lg"></div>

            <div className="z-10 flex-1 flex flex-col items-center pt-8 md:pt-10 p-4 md:p-6 pb-24 w-full">
              <div className="bg-white p-6 md:p-10 rounded-3xl shadow-2xl max-w-4xl w-full text-center mb-8 md:mb-10 animate-fade-in flex flex-col items-center border border-slate-100 relative overflow-hidden mx-auto">
                {globalSettings.adminPin && (
                  <div className="absolute top-4 right-4 bg-slate-100 text-slate-400 px-2 py-1 md:px-3 md:py-1 rounded-full text-xs font-bold flex items-center gap-1">
                    <Lock size={12} />{" "}
                    <span className="hidden sm:inline">Seguro</span>
                  </div>
                )}
                {globalSettings.logoUrl ? (
                  <img
                    src={globalSettings.logoUrl}
                    alt="Logo"
                    className="h-24 md:h-40 object-contain mb-4 md:mb-6 drop-shadow-md"
                  />
                ) : (
                  <div className="h-24 w-24 md:h-32 md:w-32 bg-slate-100 rounded-full flex items-center justify-center mb-4 md:mb-6 shadow-inner">
                    <Building2
                      size={48}
                      className="text-teal-600 md:w-16 md:h-16"
                    />
                  </div>
                )}
                <h1 className="text-3xl md:text-5xl font-black text-slate-800 mb-2 md:mb-4 tracking-tight">
                  {globalSettings.welcomeTitle || "Centro Clínico de Pruebas"}
                </h1>
                <p className="text-base md:text-xl text-slate-500 font-medium max-w-2xl leading-relaxed">
                  {globalSettings.welcomeMessage ||
                    "Bienvenido al Sistema Integral de Gestión de Turnos."}
                </p>
              </div>

              <div
                className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-6 max-w-7xl w-full animate-fade-in"
                style={{ animationDelay: "0.1s" }}
              >
                <button
                  onClick={() => handleNavigate("kiosk")}
                  className="flex flex-col items-center justify-center p-6 md:p-8 bg-white rounded-2xl shadow-lg hover:shadow-2xl hover:-translate-y-1 transition-all border-2 border-transparent hover:border-teal-500 group"
                >
                  <div className="bg-teal-50 p-4 rounded-full mb-3 md:mb-4 group-hover:bg-teal-100 transition-colors">
                    <UserPlus
                      size={40}
                      className="text-teal-600 md:w-12 md:h-12 group-hover:scale-110 transition-transform"
                    />
                  </div>
                  <h2 className="text-lg md:text-xl font-bold text-slate-800">
                    Tomar Turno
                  </h2>
                </button>
                <button
                  onClick={() => handleNavigate("display")}
                  className="flex flex-col items-center justify-center p-6 md:p-8 bg-white rounded-2xl shadow-lg hover:shadow-2xl hover:-translate-y-1 transition-all border-2 border-transparent hover:border-blue-500 group"
                >
                  <div className="bg-blue-50 p-4 rounded-full mb-3 md:mb-4 group-hover:bg-blue-100 transition-colors">
                    <MonitorPlay
                      size={40}
                      className="text-blue-500 md:w-12 md:h-12 group-hover:scale-110 transition-transform"
                    />
                  </div>
                  <h2 className="text-lg md:text-xl font-bold text-slate-800">
                    Pantalla TV
                  </h2>
                </button>
                <button
                  onClick={() => handleNavigate("orientador")}
                  className="flex flex-col items-center justify-center p-6 md:p-8 bg-white rounded-2xl shadow-lg hover:shadow-2xl hover:-translate-y-1 transition-all border-2 border-transparent hover:border-amber-500 group relative"
                >
                  {globalSettings.orientadorPin && (
                    <div className="absolute top-4 right-4 text-amber-200">
                      <Lock size={16} />
                    </div>
                  )}
                  <div className="bg-amber-50 p-4 rounded-full mb-3 md:mb-4 group-hover:bg-amber-100 transition-colors">
                    <UserCog
                      size={40}
                      className="text-amber-500 md:w-12 md:h-12 group-hover:scale-110 transition-transform"
                    />
                  </div>
                  <h2 className="text-lg md:text-xl font-bold text-slate-800">
                    Orientador
                  </h2>
                </button>
                <button
                  onClick={() => handleNavigate("agenda")}
                  className="flex flex-col items-center justify-center p-6 md:p-8 bg-white rounded-2xl shadow-lg hover:shadow-2xl hover:-translate-y-1 transition-all border-2 border-transparent hover:border-emerald-500 group relative"
                >
                  {globalSettings.agendaPin && (
                    <div className="absolute top-4 right-4 text-emerald-200">
                      <Lock size={16} />
                    </div>
                  )}
                  <div className="bg-emerald-50 p-4 rounded-full mb-3 md:mb-4 group-hover:bg-emerald-100 transition-colors">
                    <CalendarDays
                      size={40}
                      className="text-emerald-500 md:w-12 md:h-12 group-hover:scale-110 transition-transform"
                    />
                  </div>
                  <h2 className="text-lg md:text-xl font-bold text-slate-800">
                    Agendamiento
                  </h2>
                </button>
                <button
                  onClick={() => handleNavigate("staff")}
                  className="flex flex-col items-center justify-center p-6 md:p-8 bg-white rounded-2xl shadow-lg hover:shadow-2xl hover:-translate-y-1 transition-all border-2 border-transparent hover:border-indigo-500 group relative sm:col-span-2 lg:col-span-1"
                >
                  {globalSettings.staffPin && (
                    <div className="absolute top-4 right-4 text-indigo-200">
                      <Lock size={16} />
                    </div>
                  )}
                  <div className="bg-indigo-50 p-4 rounded-full mb-3 md:mb-4 group-hover:bg-indigo-100 transition-colors">
                    <Volume1
                      size={40}
                      className="text-indigo-500 md:w-12 md:h-12 group-hover:scale-110 transition-transform"
                    />
                  </div>
                  <h2 className="text-lg md:text-xl font-bold text-slate-800">
                    Atención
                  </h2>
                </button>
                <button
                  onClick={() => handleNavigate("admin")}
                  className="flex flex-col items-center justify-center p-5 md:p-6 bg-slate-800 text-white rounded-2xl shadow-lg hover:shadow-2xl hover:-translate-y-1 transition-all border border-slate-700 hover:border-slate-500 group col-span-1 sm:col-span-2 lg:col-span-5 relative overflow-hidden"
                >
                  {globalSettings.adminPin && (
                    <div className="absolute top-4 right-4 text-slate-600">
                      <Lock size={16} />
                    </div>
                  )}
                  <Settings
                    size={28}
                    className="text-slate-300 mb-2 md:mb-3 md:w-8 md:h-8 group-hover:rotate-90 transition-transform duration-500"
                  />
                  <h2 className="text-base md:text-lg font-bold">
                    Administración y Dashboard
                  </h2>
                </button>
              </div>
            </div>

            <footer className="w-full bg-slate-900 text-slate-400 py-6 md:py-8 px-4 text-center text-xs md:text-sm border-t-4 border-teal-600 mt-auto">
              <div className="max-w-4xl mx-auto space-y-2">
                <div className="flex items-center justify-center gap-2 text-teal-400 font-bold mb-4 bg-slate-800/50 py-2 px-4 rounded-full w-fit mx-auto shadow-inner">
                  <Clock size={16} />
                  <span>
                    Horario de Atención: Lunes a Viernes de 7:00 a.m. a 5:00
                    p.m.
                  </span>
                </div>
                <p className="font-black text-slate-300 text-xs md:text-sm tracking-widest mb-2 md:mb-3">
                  v2 © 2026 Sistema Integral de Turnos
                </p>
                <p className="font-bold opacity-50">TECNOLOGÍA EN PRODUCCIÓN</p>
              </div>
            </footer>
          </div>
        )}

        {activeView === "admin" && (
          <AdminView
            user={user}
            db={db}
            appId={appId}
            sedes={sedes}
            epsList={epsList}
            services={services}
            rooms={rooms}
            tickets={tickets}
            globalSettings={globalSettings}
            addEntityToDb={addEntityToDb}
            deleteEntityFromDb={deleteEntityFromDb}
            updateGlobalSettings={updateGlobalSettings}
            saveTicket={saveTicket}
            counters={counters}
            updateCounter={updateCounter}
            updateTicketStatus={updateTicketStatus}
            staffList={staffList}
            appointments={appointments}
            showToast={showToast}
          />
        )}
        {activeView === "kiosk" && (
          <KioskView
            user={user}
            db={db}
            appId={appId}
            sedes={sedes}
            epsList={epsList}
            services={services}
            counters={counters}
            saveTicket={saveTicket}
            updateCounter={updateCounter}
            globalSettings={globalSettings}
            staffList={staffList}
            appointments={appointments}
            updateAppointmentStatus={updateAppointmentStatus}
            tickets={tickets}
            showToast={showToast}
          />
        )}
        {activeView === "orientador" && (
          <OrientadorView
            sedes={sedes}
            services={services}
            rooms={rooms}
            tickets={tickets}
            updateTicketStatus={updateTicketStatus}
            staffList={staffList}
            saveTicket={saveTicket}
            counters={counters}
            updateCounter={updateCounter}
            showToast={showToast}
          />
        )}
        {activeView === "staff" && (
          <StaffView
            sedes={sedes}
            services={services}
            rooms={rooms}
            tickets={tickets}
            updateTicketStatus={updateTicketStatus}
            staffList={staffList}
            saveTicket={saveTicket}
            updateCounter={updateCounter}
            counters={counters}
            showToast={showToast}
          />
        )}
        {activeView === "display" && (
          <DisplayView
            sedes={sedes}
            tickets={tickets}
            globalSettings={globalSettings}
          />
        )}
        {activeView === "agenda" && (
          <AgendaView
            sedes={sedes}
            epsList={epsList}
            services={services}
            staffList={staffList}
            appointments={appointments}
            addEntityToDb={addEntityToDb}
            updateAppointmentStatus={updateAppointmentStatus}
            showToast={showToast}
          />
        )}
      </div>
    </div>
  );
}

// ============================================================================
// MÓDULO: ADMINISTRADOR
// ============================================================================
function AdminView({
  user,
  db,
  appId,
  sedes,
  epsList,
  services,
  rooms,
  tickets,
  globalSettings,
  addEntityToDb,
  deleteEntityFromDb,
  updateGlobalSettings,
  saveTicket,
  counters,
  updateCounter,
  updateTicketStatus,
  staffList,
  appointments,
  showToast,
}) {
  const [activeTab, setActiveTab] = useState("dashboard");

  const [sedeName, setSedeName] = useState("");
  const [sedeFloors, setSedeFloors] = useState(1);
  const [epsName, setEpsName] = useState("");
  const [selectedSedeId, setSelectedSedeId] = useState(sedes[0]?.id || "");
  const [serviceName, setServiceName] = useState("");
  const [servicePrefix, setServicePrefix] = useState("");
  const [serviceFloor, setServiceFloor] = useState("1");
  const [newRoomNames, setNewRoomNames] = useState({});

  const [staffName, setStaffName] = useState("");
  const [staffApellidos, setStaffApellidos] = useState("");
  const [staffCedula, setStaffCedula] = useState("");
  const [staffPhone, setStaffPhone] = useState("");
  const [staffEmail, setStaffEmail] = useState("");
  const [staffRole, setStaffRole] = useState("");
  const [staffServiceId, setStaffServiceId] = useState("");
  const [editingStaffId, setEditingStaffId] = useState(null);
  const [isSubmittingStaff, setIsSubmittingStaff] = useState(false);

  const [confirmDelete, setConfirmDelete] = useState({
    show: false,
    type: null,
    id: null,
    title: "",
  });
  const [demoStatus, setDemoStatus] = useState(null);
  const [logoError, setLogoError] = useState("");
  const [testResult, setTestResult] = useState(null);

  const todayStr = getLocalDateString();
  const [selectedDate, setSelectedDate] = useState(todayStr);
  const [historyTickets, setHistoryTickets] = useState([]);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);

  useEffect(() => {
    if (sedes.length > 0 && !selectedSedeId) setSelectedSedeId(sedes[0].id);
  }, [sedes, selectedSedeId]);

  useEffect(() => {
    const fetchHistory = async () => {
      if (!user || !db) return;
      setIsLoadingHistory(true);
      try {
        const q = query(
          collection(db, `artifacts/${appId}/public/data/tickets`),
          where("dateString", "==", selectedDate)
        );
        const snap = await getDocs(q);
        setHistoryTickets(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch (e) {
        showToast("Error cargando historial", "error");
      }
      setIsLoadingHistory(false);
    };
    fetchHistory();
  }, [selectedDate, user, db, appId]);

  const handleAddSede = (e) => {
    e.preventDefault();
    if (!sedeName) return;
    addEntityToDb("sedes", {
      id: Date.now().toString(),
      name: sedeName,
      floors: parseInt(sedeFloors),
    });
    setSedeName("");
    setSedeFloors(1);
  };
  const handleAddEps = (e) => {
    e.preventDefault();
    if (!epsName) return;
    addEntityToDb("eps", { id: Date.now().toString(), name: epsName });
    setEpsName("");
  };
  const handleAddService = (e) => {
    e.preventDefault();
    if (!serviceName || !servicePrefix || !selectedSedeId) return;
    addEntityToDb("services", {
      id: Date.now().toString(),
      name: serviceName,
      prefix: servicePrefix.toUpperCase().substring(0, 3),
      sedeId: selectedSedeId,
      floor: serviceFloor,
    });
    setServiceName("");
    setServicePrefix("");
  };
  const handleRoomNameChange = (serviceId, value) => {
    setNewRoomNames((prev) => ({ ...prev, [serviceId]: value }));
  };
  const handleAddRoomSpecific = (e, serviceId) => {
    e.preventDefault();
    const name = newRoomNames[serviceId];
    if (!name || !selectedSedeId) return;
    addEntityToDb("rooms", {
      id: Date.now().toString(),
      name: name,
      sedeId: selectedSedeId,
      serviceId: serviceId,
    });
    setNewRoomNames((prev) => ({ ...prev, [serviceId]: "" }));
  };

  const handleAddStaff = async (e) => {
    e.preventDefault();
    if (
      !staffName ||
      !staffApellidos ||
      !staffCedula ||
      !staffRole ||
      !staffServiceId ||
      isSubmittingStaff
    )
      return;
    setIsSubmittingStaff(true);
    await addEntityToDb("staff", {
      id: editingStaffId || Date.now().toString(),
      name: staffName,
      apellidos: staffApellidos,
      cedula: staffCedula,
      phone: staffPhone,
      email: staffEmail,
      role: staffRole,
      serviceId: staffServiceId,
    });
    setStaffName("");
    setStaffApellidos("");
    setStaffCedula("");
    setStaffPhone("");
    setStaffEmail("");
    setStaffRole("");
    setStaffServiceId("");
    setEditingStaffId(null);
    setIsSubmittingStaff(false);
  };

  const loadStaffForEdit = (staff) => {
    setStaffName(staff.name);
    setStaffApellidos(staff.apellidos);
    setStaffCedula(staff.cedula);
    setStaffPhone(staff.phone || "");
    setStaffEmail(staff.email || "");
    setStaffRole(staff.role);
    setStaffServiceId(staff.serviceId);
    setEditingStaffId(staff.id);
    setActiveTab("rrhh");
  };

  const handleLogoUpload = (e) => {
    setLogoError("");
    const file = e.target.files[0];
    if (file) {
      if (file.size > 200000) {
        setLogoError(
          "La imagen es muy pesada. Por favor sube un logo menor a 200KB."
        );
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        updateGlobalSettings({ logoUrl: reader.result });
      };
      reader.readAsDataURL(file);
    }
  };

  const triggerDelete = (type, id, title) =>
    setConfirmDelete({ show: true, type, id, title });
  const executeDelete = async () => {
    if (confirmDelete.type === "services")
      showToast(
        "Área eliminada. Revisa los consultorios asignados.",
        "success"
      );
    await deleteEntityFromDb(confirmDelete.type, confirmDelete.id);
    setConfirmDelete({ show: false, type: null, id: null, title: "" });
  };

  const generateDemoData = async () => {
    if (sedes.length === 0) {
      setDemoStatus({
        type: "error",
        msg: "Error: Falta crear una Sede Clínica.",
      });
      setTimeout(() => setDemoStatus(null), 4000);
      return;
    }
    if (services.length === 0) {
      setDemoStatus({
        type: "error",
        msg: "Error: Falta crear un Área de Servicio.",
      });
      setTimeout(() => setDemoStatus(null), 4000);
      return;
    }
    if (rooms.length === 0) {
      setDemoStatus({
        type: "error",
        msg: "Error: Falta agregar un Espacio a tu Área.",
      });
      setTimeout(() => setDemoStatus(null), 4000);
      return;
    }
    if (!user || !db) {
      showToast("Error de conexión a la base de datos", "error");
      return;
    }

    setDemoStatus({
      type: "loading",
      msg: "Generando datos reales y citas...",
    });
    const demoNames = [
      "María González",
      "Carlos Rodríguez",
      "Ana Martínez",
      "Pedro Sánchez",
      "Laura López",
      "Javier Gómez",
      "Carmen Ruiz",
      "Miguel Fernández",
      "Isabel Díaz",
      "Raúl Morales",
    ];
    let countGenerated = 0;

    try {
      for (const service of services) {
        const sede = sedes.find((s) => s.id === service.sedeId) || sedes[0];
        const serviceRooms = rooms.filter((r) => r.serviceId === service.id);
        const serviceStaff = staffList.filter(
          (s) => s.serviceId === service.id
        );

        const scenarios = [
          {
            status: "waiting",
            priority: false,
            calledAt: null,
            finishedAt: null,
            room: null,
            note: null,
            appointmentTime: null,
          },
          {
            status: "waiting",
            priority: true,
            calledAt: null,
            finishedAt: null,
            room: null,
            note: null,
            appointmentTime: `08:10`,
          },
          {
            status: "called",
            priority: false,
            calledAt: Date.now() - 300000,
            finishedAt: null,
            room: serviceRooms[0],
            note: null,
            appointmentTime: null,
          },
          {
            status: "finished",
            priority: true,
            calledAt: Date.now() - 1500000,
            finishedAt: Date.now() - 300000,
            room: serviceRooms[0],
            note: "Paciente dado de alta.",
            appointmentTime: `07:15`,
          },
          {
            status: "paused",
            priority: false,
            calledAt: Date.now() - 1800000,
            finishedAt: null,
            room: serviceRooms[0],
            note: "Esperando resultados.",
            appointmentTime: null,
          },
          {
            status: "absent",
            priority: false,
            calledAt: Date.now() - 2000000,
            finishedAt: Date.now() - 1000000,
            room: serviceRooms[0],
            note: "No responde.",
            appointmentTime: null,
          },
          {
            status: "transferred",
            priority: false,
            calledAt: Date.now() - 5000000,
            finishedAt: Date.now() - 4000000,
            room: serviceRooms[0],
            note: "Se remite paciente.",
            appointmentTime: null,
          },
        ];

        for (const scenario of scenarios) {
          if (
            !scenario.room &&
            ["called", "finished", "absent", "transferred", "paused"].includes(
              scenario.status
            )
          )
            continue;

          const assignedStaff =
            serviceStaff.length > 0
              ? serviceStaff[Math.floor(Math.random() * serviceStaff.length)]
              : null;
          const rndCedula = Math.floor(
            10000000 + Math.random() * 90000000
          ).toString();
          const rndName =
            demoNames[Math.floor(Math.random() * demoNames.length)];

          if (scenario.appointmentTime) {
            await addEntityToDb("appointments", {
              id: `demo-appt-${Date.now()}-${countGenerated}`,
              cedula: rndCedula,
              name: rndName,
              apellidos: "Demo",
              celular: "3000000000",
              eps: epsList.length > 0 ? epsList[0].name : "Particular",
              sedeId: sede.id,
              serviceId: service.id,
              staffId: assignedStaff ? assignedStaff.id : "",
              date: todayStr,
              time: scenario.appointmentTime,
              status: scenario.status === "waiting" ? "pending" : "arrived",
              serviceName: service.name,
              staffName: assignedStaff
                ? `${assignedStaff.name} ${assignedStaff.apellidos}`
                : null,
              sedeName: sede.name,
            });
          }

          const counterRef = doc(
            db,
            `artifacts/${appId}/public/data/counters`,
            service.id
          );
          const newTicketId = `demo-tkt-${Date.now()}-${countGenerated}`;
          const ticketRef = doc(
            db,
            `artifacts/${appId}/public/data/tickets`,
            newTicketId
          );

          await runTransaction(db, async (transaction) => {
            const counterDoc = await transaction.get(counterRef);
            const currentCount = counterDoc.exists()
              ? counterDoc.data().count
              : 0;
            const nextCount = currentCount + 1;
            const ticketNumber = `${service.prefix}-${nextCount
              .toString()
              .padStart(3, "0")}`;

            const newTicket = {
              id: newTicketId,
              number: ticketNumber,
              sedeId: sede.id,
              sedeName: sede.name,
              serviceId: service.id,
              serviceName: service.name,
              floor: service.floor || "1",
              name: rndName,
              apellidos: "Demo",
              cedula: rndCedula,
              celular:
                "300" +
                Math.floor(1000000 + Math.random() * 9000000).toString(),
              correo: `demo${countGenerated}@correo.com`,
              eps:
                epsList.length > 0
                  ? epsList[Math.floor(Math.random() * epsList.length)].name
                  : "Particular",
              priority: scenario.priority,
              status: scenario.status,
              roomId: scenario.room ? scenario.room.name : null,
              staffId: assignedStaff ? assignedStaff.id : null,
              staffName: assignedStaff
                ? `${assignedStaff.name} ${assignedStaff.apellidos}`
                : null,
              staffNote: scenario.note,
              appointmentTime: scenario.appointmentTime,
              timestamp: Date.now() - Math.random() * 7200000,
              calledAt: scenario.calledAt,
              finishedAt: scenario.finishedAt,
              dateString: todayStr,
            };
            transaction.set(counterRef, { count: nextCount });
            transaction.set(ticketRef, newTicket);
          });
          countGenerated++;
        }
      }

      if (services.length > 0) {
        const multiCedula = "99999999";
        await addEntityToDb("appointments", {
          id: `demo-appt-multi-1`,
          cedula: multiCedula,
          name: "Paciente",
          apellidos: "Multicita",
          celular: "300",
          eps: "Particular",
          sedeId: sedes[0].id,
          serviceId: services[0].id,
          staffId: "",
          date: todayStr,
          time: "09:00",
          status: "pending",
          serviceName: services[0].name,
          staffName: null,
          sedeName: sedes[0].name,
        });
        const secondService = services.length > 1 ? services[1] : services[0];
        await addEntityToDb("appointments", {
          id: `demo-appt-multi-2`,
          cedula: multiCedula,
          name: "Paciente",
          apellidos: "Multicita",
          celular: "300",
          eps: "Particular",
          sedeId: sedes[0].id,
          serviceId: secondService.id,
          staffId: "",
          date: todayStr,
          time: "11:30",
          status: "pending",
          serviceName: secondService.name,
          staffName: null,
          sedeName: sedes[0].name,
        });
        countGenerated += 2;
      }

      setDemoStatus({
        type: "success",
        msg: `¡${countGenerated} registros creados! Prueba CC: 99999999 en Kiosco.`,
      });
      showToast("Datos Demo generados correctamente.", "success");
    } catch (e) {
      setDemoStatus({
        type: "error",
        msg: "Error al generar datos. Verifique la base de datos.",
      });
      showToast("Error en la transacción demo.", "error");
    }
    setTimeout(() => setDemoStatus(null), 6000);
  };

  const runSystemTest = async () => {
    setTestResult({
      status: "running",
      logs: ["Iniciando pruebas atómicas..."],
      errorDetails: "",
    });
    let currentLogs = ["Iniciando pruebas atómicas..."];
    const addLog = (msg) => {
      currentLogs.push(msg);
      setTestResult((prev) => ({ ...prev, logs: [...currentLogs] }));
    };
    try {
      const testId = `test-${Date.now()}`;
      addLog("1. Probando creación de Sede y Áreas...");
      await addEntityToDb("sedes", {
        id: testId,
        name: "Sede Test",
        floors: 1,
      });
      await addEntityToDb("services", {
        id: testId,
        name: "Área Test",
        prefix: "TST",
        sedeId: testId,
        floor: "1",
      });
      addLog("✅ Creados.");
      addLog("2. Probando creación de Personal (RRHH)...");
      await addEntityToDb("staff", {
        id: testId,
        name: "Dr. Test",
        apellidos: "Sistema",
        cedula: "000000",
        role: "Médico General",
        serviceId: testId,
      });
      addLog("✅ Personal creado.");
      addLog("3. Probando Módulo de Agendamiento...");
      await addEntityToDb("appointments", {
        id: testId,
        cedula: "123456",
        name: "Paciente",
        date: todayStr,
        time: "10:00",
        status: "pending",
        staffId: testId,
      });
      addLog("✅ Cita agendada.");
      addLog("4. Probando filtro de colisión de citas...");
      const mockAppointments = [
        { date: todayStr, time: "10:00", staffId: testId, status: "pending" },
      ];
      const hasConflict = mockAppointments.some(
        (a) =>
          a.date === todayStr &&
          a.time === "10:00" &&
          a.staffId === testId &&
          a.status !== "cancelled"
      );
      if (hasConflict)
        addLog(
          "✅ Filtro anticolisiones bloquea cita duplicada correctamente."
        );
      else throw new Error("El filtro de colisión falló.");

      addLog("5. Probando Transacción Atómica de Turno (Kiosco Simulado)...");
      const counterRef = doc(
        db,
        `artifacts/${appId}/public/data/counters`,
        testId
      );
      const ticketRef = doc(
        db,
        `artifacts/${appId}/public/data/tickets`,
        testId
      );
      await runTransaction(db, async (transaction) => {
        transaction.set(counterRef, { count: 1 });
        transaction.set(ticketRef, {
          id: testId,
          number: "TST-001",
          sedeId: testId,
          serviceId: testId,
          name: "Paciente",
          cedula: "123456",
          status: "waiting",
          timestamp: Date.now(),
          dateString: todayStr,
        });
      });
      addLog("✅ Turno atómico creado con éxito.");

      addLog("6. Probando Flujos (Llamado y Pausa)...");
      await updateTicketStatus(testId, { status: "paused", roomId: null });
      addLog("✅ Estado Pausado guardado.");
      addLog("7. Probando Traslado con Notas...");
      await updateTicketStatus(testId, {
        status: "transferred",
        finishedAt: Date.now(),
        staffNote: "QA Test OK.",
      });
      addLog("✅ Nota y Traslado OK.");
      addLog("8. Limpieza...");
      await deleteEntityFromDb("tickets", testId);
      await deleteEntityFromDb("counters", testId);
      await deleteEntityFromDb("appointments", testId);
      await deleteEntityFromDb("staff", testId);
      await deleteEntityFromDb("rooms", testId);
      await deleteEntityFromDb("services", testId);
      await deleteEntityFromDb("eps", testId);
      await deleteEntityFromDb("sedes", testId);
      addLog("✅ Limpieza completada.");
      addLog("🎉 TODAS LAS PRUEBAS FUERON EXITOSAS.");
      setTestResult({ status: "success", logs: currentLogs, errorDetails: "" });
      showToast("Prueba de Integridad superada", "success");
    } catch (error) {
      addLog(`❌ ERROR ENCONTRADO: ${error.message}`);
      setTestResult({
        status: "error",
        logs: currentLogs,
        errorDetails: error.stack || error.toString(),
      });
      showToast("Error crítico detectado", "error");
    }
  };

  const downloadTestReport = () => {
    if (!testResult) return;
    const blob = new Blob(
      [
        `REPORTE QA - SISTEMA\n\n${testResult.logs.join("\n")}\n\nERROR:\n${
          testResult.errorDetails
        }`,
      ],
      { type: "text/plain" }
    );
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `QA_${Date.now()}.txt`;
    link.click();
  };
  const downloadHistoryTXT = () => {
    let textContent = `REPORTE DE TURNOS - FECHA: ${selectedDate}\n==========================================\n\n`;
    if (historyTickets.length === 0)
      textContent += `No se encontraron turnos.\n`;
    else {
      [...historyTickets]
        .sort((a, b) => a.timestamp - b.timestamp)
        .forEach((t) => {
          textContent += `Turno: ${t.number} | Área: ${
            t.serviceName
          } | Paciente: ${t.name} ${t.apellidos} | ID: ${
            t.cedula
          }\nLlegada: ${new Date(
            t.timestamp
          ).toLocaleTimeString()} | Estado: ${t.status.toUpperCase()}\n`;
          if (t.calledAt)
            textContent += `Llamado: ${new Date(
              t.calledAt
            ).toLocaleTimeString()} (Consultorio: ${t.roomId})\n`;
          if (t.finishedAt)
            textContent += `Salida: ${new Date(
              t.finishedAt
            ).toLocaleTimeString()}\n`;
          if (t.staffNote) textContent += `Nota Clínica: ${t.staffNote}\n`;
          textContent += `------------------------------------------\n`;
        });
      textContent += `\nTotal: ${historyTickets.length} turnos\n`;
    }
    const blob = new Blob([textContent], { type: "text/plain" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Turnos_${selectedDate}.txt`;
    link.click();
  };

  const stats = useMemo(() => {
    const waiting = tickets.filter((t) => t.status === "waiting").length;
    const called = tickets.filter((t) => t.status === "called").length;
    const finished = tickets.filter((t) => t.status === "finished").length;
    const absent = tickets.filter((t) => t.status === "absent").length;
    const paused = tickets.filter((t) => t.status === "paused").length;

    let avgWaitTime = 0;
    const calledOrFinished = tickets.filter((t) => t.calledAt && t.timestamp);
    if (calledOrFinished.length > 0) {
      avgWaitTime = Math.round(
        calledOrFinished.reduce(
          (acc, t) => acc + (t.calledAt - t.timestamp),
          0
        ) /
          calledOrFinished.length /
          60000
      );
    }
    return {
      total: tickets.length,
      waiting,
      called,
      finished,
      absent,
      paused,
      avgWaitTime,
    };
  }, [tickets]);

  return (
    <div className="p-4 md:p-6 max-w-7xl mx-auto h-full flex flex-col relative print:hidden">
      {confirmDelete.show && (
        <div className="absolute inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm rounded-xl p-4">
          <div className="bg-white p-6 rounded-2xl shadow-2xl max-w-sm w-full animate-pop-in">
            <div className="flex items-center gap-3 text-red-600 mb-4">
              <AlertTriangle size={32} />
              <h3 className="text-xl font-bold">¿Eliminar?</h3>
            </div>
            <p className="text-slate-600 mb-6">
              Se borrará: <strong>{confirmDelete.title}</strong>.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={() =>
                  setConfirmDelete({
                    show: false,
                    type: null,
                    id: null,
                    title: "",
                  })
                }
                className="flex-1 py-3 sm:py-2 bg-slate-100 font-bold rounded-xl hover:bg-slate-200"
              >
                Cancelar
              </button>
              <button
                onClick={executeDelete}
                className="flex-1 py-3 sm:py-2 bg-red-600 text-white font-bold rounded-xl hover:bg-red-700"
              >
                Borrar
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-6 gap-4 border-b border-slate-300 pb-4">
        <h2 className="text-2xl md:text-3xl font-bold text-slate-800 flex items-center gap-2">
          <Settings className="text-slate-600" /> Administración
        </h2>
        <div className="flex bg-slate-200 p-1.5 rounded-xl w-full lg:w-auto overflow-x-auto shadow-inner hide-scrollbar">
          <button
            onClick={() => setActiveTab("dashboard")}
            className={`px-4 py-2 whitespace-nowrap rounded-lg font-bold transition-all flex items-center gap-2 ${
              activeTab === "dashboard"
                ? "bg-white text-teal-700 shadow-md"
                : "text-slate-600 hover:text-slate-900"
            }`}
          >
            <PieChart size={16} /> Vivo
          </button>
          <button
            onClick={() => setActiveTab("config")}
            className={`px-4 py-2 whitespace-nowrap rounded-lg font-bold transition-all ${
              activeTab === "config"
                ? "bg-white text-teal-700 shadow-md"
                : "text-slate-600 hover:text-slate-900"
            }`}
          >
            Sedes/Áreas
          </button>
          <button
            onClick={() => setActiveTab("eps")}
            className={`px-4 py-2 whitespace-nowrap rounded-lg font-bold transition-all ${
              activeTab === "eps"
                ? "bg-white text-teal-700 shadow-md"
                : "text-slate-600 hover:text-slate-900"
            }`}
          >
            EPS
          </button>
          <button
            onClick={() => setActiveTab("rrhh")}
            className={`px-4 py-2 whitespace-nowrap rounded-lg font-bold transition-all ${
              activeTab === "rrhh"
                ? "bg-white text-teal-700 shadow-md"
                : "text-slate-600 hover:text-slate-900"
            }`}
          >
            RRHH
          </button>
          <button
            onClick={() => setActiveTab("system")}
            className={`px-4 py-2 whitespace-nowrap rounded-lg font-bold transition-all ${
              activeTab === "system"
                ? "bg-white text-teal-700 shadow-md"
                : "text-slate-600 hover:text-slate-900"
            }`}
          >
            Sistema
          </button>
          <button
            onClick={() => setActiveTab("history")}
            className={`px-4 py-2 whitespace-nowrap rounded-lg font-bold transition-all flex items-center gap-1 ${
              activeTab === "history"
                ? "bg-slate-800 text-white shadow-md"
                : "text-slate-600 hover:text-slate-900"
            }`}
          >
            <FileText size={16} /> Historial
          </button>
        </div>
      </div>

      {activeTab === "dashboard" && (
        <div className="animate-fade-in flex-1 overflow-y-auto pb-6 space-y-6">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center bg-slate-800 text-white p-4 rounded-2xl shadow gap-4">
            <h3 className="text-lg font-bold flex items-center gap-2">
              <PieChart /> Resumen en Vivo (HOY)
            </h3>
            <div className="text-sm font-medium text-slate-300">
              Actualizado en tiempo real
            </div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            <div className="bg-white p-4 md:p-6 rounded-2xl shadow-sm border border-slate-200 flex flex-col items-center justify-center text-center">
              <span className="text-slate-500 text-xs font-bold uppercase mb-2">
                Total Turnos
              </span>
              <span className="text-3xl font-black text-slate-800">
                {stats.total}
              </span>
            </div>
            <div className="bg-amber-50 p-4 md:p-6 rounded-2xl shadow-sm border border-amber-200 flex flex-col items-center justify-center text-center">
              <span className="text-amber-700 text-xs font-bold uppercase mb-2">
                En Espera
              </span>
              <span className="text-3xl font-black text-amber-600">
                {stats.waiting}
              </span>
            </div>
            <div className="bg-yellow-50 p-4 md:p-6 rounded-2xl shadow-sm border border-yellow-200 flex flex-col items-center justify-center text-center">
              <span className="text-yellow-700 text-xs font-bold uppercase mb-2">
                En Examen
              </span>
              <span className="text-3xl font-black text-yellow-600">
                {stats.paused}
              </span>
            </div>
            <div className="bg-indigo-50 p-4 md:p-6 rounded-2xl shadow-sm border border-indigo-200 flex flex-col items-center justify-center text-center">
              <span className="text-indigo-700 text-xs font-bold uppercase mb-2">
                En Atención
              </span>
              <span className="text-3xl font-black text-indigo-600">
                {stats.called}
              </span>
            </div>
            <div className="bg-green-50 p-4 md:p-6 rounded-2xl shadow-sm border border-green-200 flex flex-col items-center justify-center text-center">
              <span className="text-green-700 text-xs font-bold uppercase mb-2">
                Finalizados
              </span>
              <span className="text-3xl font-black text-green-600">
                {stats.finished}
              </span>
            </div>
            <div className="bg-red-50 p-4 md:p-6 rounded-2xl shadow-sm border border-red-200 flex flex-col items-center justify-center text-center">
              <span className="text-red-700 text-xs font-bold uppercase mb-2">
                Ausentes
              </span>
              <span className="text-3xl font-black text-red-600">
                {stats.absent}
              </span>
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200 flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
              <div>
                <h4 className="text-lg font-bold text-slate-800">
                  Tiempo Promedio de Espera
                </h4>
                <p className="text-sm text-slate-500">
                  Desde que saca turno hasta que es llamado.
                </p>
              </div>
              <div>
                <span className="text-5xl font-black text-teal-600">
                  {stats.avgWaitTime}
                </span>
                <span className="text-xl font-bold text-slate-400 ml-1">
                  min
                </span>
              </div>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200 flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
              <div>
                <h4 className="text-lg font-bold text-slate-800">
                  Tasa de Eficiencia
                </h4>
                <p className="text-sm text-slate-500">
                  Porcentaje de pacientes atendidos hoy.
                </p>
              </div>
              <div>
                <span className="text-5xl font-black text-blue-600">
                  {stats.total > 0
                    ? Math.round(
                        (stats.finished /
                          (stats.finished + stats.absent || 1)) *
                          100
                      )
                    : 0}
                  %
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === "eps" && (
        <div className="animate-fade-in flex-1 overflow-y-auto pb-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200 h-fit">
              <h3 className="text-xl font-bold mb-4 text-slate-800 flex items-center gap-2">
                <ShieldPlus className="text-blue-600" /> Agregar EPS
              </h3>
              <form
                onSubmit={handleAddEps}
                className="flex flex-col sm:flex-row gap-3"
              >
                <input
                  type="text"
                  value={epsName}
                  onChange={(e) => setEpsName(e.target.value)}
                  className="flex-1 p-3 border border-slate-300 rounded-xl focus:ring-2 outline-none"
                  placeholder="Nombre EPS"
                  required
                />
                <button
                  type="submit"
                  className="bg-blue-600 text-white px-5 py-3 rounded-xl font-bold hover:bg-blue-700"
                >
                  Agregar
                </button>
              </form>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200">
              <h3 className="text-lg font-bold mb-4 text-slate-800">
                Lista de EPS
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-h-[60vh] overflow-y-auto pr-2">
                {[...epsList]
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((e) => (
                    <div
                      key={e.id}
                      className="flex justify-between items-center p-3 border border-slate-100 rounded-xl bg-blue-50/30"
                    >
                      <span className="font-medium text-slate-700 text-sm truncate">
                        {e.name}
                      </span>
                      <button
                        onClick={() => triggerDelete("eps", e.id, e.name)}
                        className="text-red-400 hover:text-red-600 p-1.5 bg-white rounded-md shadow-sm border border-slate-100"
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === "rrhh" && (
        <div className="animate-fade-in flex-1 overflow-y-auto pb-6 space-y-6">
          <div
            className={`bg-white p-6 rounded-2xl shadow-sm border ${
              editingStaffId
                ? "border-amber-400 shadow-amber-100"
                : "border-slate-200"
            }`}
          >
            <h3 className="text-xl font-bold mb-6 text-slate-800 flex items-center gap-2">
              <Users
                className={editingStaffId ? "text-amber-500" : "text-teal-600"}
              />{" "}
              {editingStaffId ? "Editando Personal" : "Alta de Personal"}
            </h3>
            <form onSubmit={handleAddStaff} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-bold text-slate-700 mb-1">
                    Nombres *
                  </label>
                  <input
                    type="text"
                    value={staffName}
                    onChange={(e) => setStaffName(e.target.value)}
                    className="w-full p-3 border rounded-xl focus:ring-2 outline-none"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-bold text-slate-700 mb-1">
                    Apellidos *
                  </label>
                  <input
                    type="text"
                    value={staffApellidos}
                    onChange={(e) => setStaffApellidos(e.target.value)}
                    className="w-full p-3 border rounded-xl focus:ring-2 outline-none"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-bold text-slate-700 mb-1">
                    Cédula / ID *
                  </label>
                  <input
                    type="text"
                    value={staffCedula}
                    onChange={(e) => setStaffCedula(e.target.value)}
                    className="w-full p-3 border rounded-xl focus:ring-2 outline-none"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-bold text-slate-700 mb-1">
                    Celular
                  </label>
                  <input
                    type="text"
                    value={staffPhone}
                    onChange={(e) => setStaffPhone(e.target.value)}
                    className="w-full p-3 border rounded-xl focus:ring-2 outline-none"
                  />
                </div>
                <div>
                  <label className="block text-sm font-bold text-slate-700 mb-1">
                    Correo Electrónico
                  </label>
                  <input
                    type="email"
                    value={staffEmail}
                    onChange={(e) => setStaffEmail(e.target.value)}
                    className="w-full p-3 border rounded-xl focus:ring-2 outline-none"
                  />
                </div>
                <div>
                  <label className="block text-sm font-bold text-slate-700 mb-1">
                    Cargo *
                  </label>
                  <select
                    value={staffRole}
                    onChange={(e) => setStaffRole(e.target.value)}
                    className="w-full p-3 border rounded-xl focus:ring-2 outline-none cursor-pointer"
                    required
                  >
                    <option value="">-- Seleccionar --</option>
                    <option value="Médico General">Médico General</option>
                    <option value="Médico Especialista">
                      Médico Especialista
                    </option>
                    <option value="Oncólogo Clínico">Oncólogo Clínico</option>
                    <option value="Enfermero/a Jefe">Enfermero/a Jefe</option>
                    <option value="Aux. Enfermería">
                      Auxiliar de Enfermería
                    </option>
                    <option value="Admisiones / Recepción">Admisiones</option>
                    <option value="Orientador">Orientador</option>
                    <option value="Otro">Otro</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-2 border-t mt-4">
                <div className="lg:col-span-2">
                  <label className="block text-sm font-bold text-slate-700 mb-1">
                    Área Asignada *
                  </label>
                  <select
                    value={staffServiceId}
                    onChange={(e) => setStaffServiceId(e.target.value)}
                    className="w-full p-3 border border-teal-300 bg-teal-50 rounded-xl focus:ring-2 outline-none cursor-pointer"
                    required
                  >
                    <option value="">-- Seleccionar --</option>
                    {services.map((s) => (
                      <option key={s.id} value={s.id}>
                        {s.name} ({sedes.find((sd) => sd.id === s.sedeId)?.name}
                        )
                      </option>
                    ))}
                  </select>
                </div>
                <div className="flex flex-col sm:flex-row items-end gap-2 mt-4 lg:mt-0">
                  {editingStaffId && (
                    <button
                      type="button"
                      onClick={() => {
                        setEditingStaffId(null);
                        setStaffName("");
                        setStaffApellidos("");
                        setStaffCedula("");
                        setStaffPhone("");
                        setStaffEmail("");
                        setStaffRole("");
                        setStaffServiceId("");
                      }}
                      className="w-full sm:w-auto flex-1 bg-slate-200 text-slate-700 px-4 py-3 rounded-xl font-bold hover:bg-slate-300"
                    >
                      Cancelar
                    </button>
                  )}
                  <button
                    type="submit"
                    disabled={isSubmittingStaff}
                    className={`w-full sm:w-auto flex-1 text-white px-6 py-3 rounded-xl font-bold flex items-center justify-center gap-2 shadow-md ${
                      isSubmittingStaff ? "opacity-50" : ""
                    } ${
                      editingStaffId
                        ? "bg-amber-500 hover:bg-amber-600"
                        : "bg-teal-600 hover:bg-teal-700"
                    }`}
                  >
                    {isSubmittingStaff ? (
                      <Loader2 className="animate-spin" size={18} />
                    ) : editingStaffId ? (
                      <Edit2 size={18} />
                    ) : (
                      <UserPlus size={18} />
                    )}{" "}
                    Guardar
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200">
            <h3 className="text-xl font-bold mb-4 text-slate-800 flex items-center gap-2">
              <Briefcase className="text-indigo-600" /> Personal Registrado
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {staffList.map((staff) => (
                <div
                  key={staff.id}
                  className={`border rounded-xl p-4 flex flex-col relative bg-slate-50 transition-colors ${
                    editingStaffId === staff.id
                      ? "border-amber-400 bg-amber-50/30"
                      : "border-slate-200 hover:border-teal-300"
                  }`}
                >
                  <div className="absolute top-4 right-4 flex gap-1">
                    <button
                      onClick={() => loadStaffForEdit(staff)}
                      className="text-slate-400 hover:text-amber-500 bg-white p-1.5 rounded shadow-sm border border-slate-100"
                    >
                      <Edit2 size={16} />
                    </button>
                    <button
                      onClick={() =>
                        triggerDelete(
                          "staff",
                          staff.id,
                          `${staff.name} ${staff.apellidos}`
                        )
                      }
                      className="text-red-400 hover:text-red-600 bg-white p-1.5 rounded shadow-sm border border-slate-100"
                    >
                      <Trash2 size={16} />
                    </button>
                  </div>
                  <div className="flex items-center gap-3 mb-3 pr-16">
                    <div
                      className={`p-3 rounded-full ${
                        editingStaffId === staff.id
                          ? "bg-amber-100 text-amber-600"
                          : "bg-indigo-100 text-indigo-600"
                      }`}
                    >
                      <UserCircle size={28} />
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-800 leading-tight">
                        {staff.name} {staff.apellidos}
                      </h4>
                      <span className="text-xs font-bold text-teal-600">
                        {staff.role}
                      </span>
                    </div>
                  </div>
                  <div className="text-xs text-slate-500 space-y-1">
                    <p>
                      <Contact size={12} className="inline mr-1" /> CC:{" "}
                      {staff.cedula}
                    </p>
                    <p className="truncate">
                      <strong>Área:</strong>{" "}
                      {services.find((s) => s.id === staff.serviceId)?.name ||
                        "N/A"}
                    </p>
                  </div>
                </div>
              ))}
              {staffList.length === 0 && (
                <div className="col-span-full text-center p-8 border border-dashed rounded-xl text-slate-400">
                  No hay personal registrado en el sistema.
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {activeTab === "config" && (
        <div className="animate-fade-in flex-1 overflow-y-auto pb-6 space-y-6">
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200">
            <h3 className="text-xl font-bold mb-4 text-slate-800 flex items-center gap-2">
              <Building2 className="text-teal-600" /> 1. Gestión de Sedes
            </h3>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div className="lg:col-span-1">
                <form onSubmit={handleAddSede} className="flex flex-col gap-3">
                  <input
                    type="text"
                    value={sedeName}
                    onChange={(e) => setSedeName(e.target.value)}
                    className="w-full p-3 border border-slate-300 rounded-xl focus:ring-2 outline-none"
                    placeholder="Nombre (Ej. Sede Norte)"
                    required
                  />
                  <div className="relative">
                    <span className="absolute left-3 top-3.5 text-xs font-bold text-slate-400">
                      Pisos
                    </span>
                    <input
                      type="number"
                      min="1"
                      max="20"
                      value={sedeFloors}
                      onChange={(e) => setSedeFloors(e.target.value)}
                      className="w-full p-3 pl-12 border border-slate-300 rounded-xl focus:ring-2 outline-none"
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    className="bg-teal-600 text-white px-4 py-3 rounded-xl font-bold hover:bg-teal-700 flex justify-center items-center gap-2"
                  >
                    <Plus size={18} /> Agregar Sede
                  </button>
                </form>
              </div>
              <div className="lg:col-span-2 space-y-2 max-h-48 overflow-y-auto pr-2">
                {sedes.map((s) => (
                  <div
                    key={s.id}
                    className="flex justify-between items-center p-3 border border-slate-100 rounded-xl bg-slate-50"
                  >
                    <span className="font-bold text-slate-700 flex items-center gap-2">
                      <MapPin size={16} className="text-slate-400" /> {s.name}{" "}
                      <span className="text-xs bg-slate-200 px-2 py-0.5 rounded-full text-slate-600">
                        {s.floors} Pisos
                      </span>
                    </span>
                    <button
                      onClick={() => triggerDelete("sedes", s.id, s.name)}
                      className="text-red-400 hover:bg-red-50 p-2 rounded-lg transition-colors"
                    >
                      <Trash2 size={18} />
                    </button>
                  </div>
                ))}
                {sedes.length === 0 && (
                  <p className="text-sm text-slate-400 p-4 border border-dashed rounded-xl text-center">
                    No hay sedes registradas.
                  </p>
                )}
              </div>
            </div>
          </div>

          <div className="bg-slate-800 p-5 rounded-2xl shadow-md flex flex-col sm:flex-row items-start sm:items-center gap-4 text-white">
            <MapPin size={28} className="text-teal-400 hidden sm:block" />
            <div className="w-full sm:w-auto">
              <p className="text-xs text-slate-400 font-bold uppercase tracking-wider mb-1 sm:mb-0">
                Configurando áreas para:
              </p>
              <select
                value={selectedSedeId}
                onChange={(e) => setSelectedSedeId(e.target.value)}
                className="w-full sm:w-auto bg-slate-700 text-white text-lg md:text-2xl font-bold outline-none border-b border-slate-600 focus:border-teal-400 pb-1 cursor-pointer p-2 sm:p-0 rounded sm:rounded-none sm:bg-transparent"
              >
                {sedes.map((s) => (
                  <option key={s.id} value={s.id} className="text-slate-800">
                    {s.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200 mb-6">
            <h3 className="text-xl font-bold mb-4 text-slate-800 flex items-center gap-2">
              <Layers className="text-teal-600" /> 2. Crear Área de Servicio
            </h3>
            <form
              onSubmit={handleAddService}
              className="flex flex-col md:flex-row gap-3"
            >
              <input
                type="text"
                value={serviceName}
                onChange={(e) => setServiceName(e.target.value)}
                className="flex-[2] p-3 border rounded-xl focus:ring-2 outline-none"
                placeholder="Nombre (Ej. Laboratorio)"
                required
              />
              <div className="flex gap-3 flex-1">
                <input
                  type="text"
                  value={servicePrefix}
                  onChange={(e) => setServicePrefix(e.target.value)}
                  maxLength={3}
                  className="w-1/2 p-3 border rounded-xl focus:ring-2 outline-none uppercase"
                  placeholder="PREFIJO"
                  required
                />
                <select
                  value={serviceFloor}
                  onChange={(e) => setServiceFloor(e.target.value)}
                  className="w-1/2 p-3 border rounded-xl focus:ring-2 outline-none bg-slate-50 cursor-pointer"
                >
                  {[
                    ...Array(
                      sedes.find((s) => s.id === selectedSedeId)?.floors || 1
                    ),
                  ].map((_, i) => (
                    <option key={i + 1} value={i + 1}>
                      Piso {i + 1}
                    </option>
                  ))}
                </select>
              </div>
              <button
                type="submit"
                className="bg-teal-600 text-white px-6 py-3 rounded-xl font-bold hover:bg-teal-700 flex items-center justify-center gap-2"
              >
                <Plus size={18} /> Agregar
              </button>
            </form>
          </div>

          <div className="space-y-4">
            <h3 className="text-xl font-bold text-slate-800 flex items-center gap-2">
              <DoorOpen className="text-indigo-600" /> 3. Consultorios por Área
            </h3>
            {services.filter((s) => s.sedeId === selectedSedeId).length ===
              0 && (
              <p className="text-slate-500 bg-white p-6 rounded-2xl border border-dashed text-center">
                No hay áreas de servicio creadas en esta sede.
              </p>
            )}

            {services
              .filter((s) => s.sedeId === selectedSedeId)
              .map((s) => (
                <div
                  key={s.id}
                  className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden"
                >
                  <div className="bg-slate-50 p-4 border-b border-slate-200 flex justify-between items-center">
                    <div>
                      <span className="font-black text-teal-700 mr-2 md:mr-3 text-base md:text-lg">
                        {s.prefix}
                      </span>
                      <span className="font-bold text-slate-800 text-base md:text-lg">
                        {s.name}
                      </span>
                      <span className="text-xs ml-2 md:ml-3 text-slate-500 bg-slate-200 px-2 py-1 rounded-full font-bold whitespace-nowrap">
                        Piso {s.floor}
                      </span>
                    </div>
                    <button
                      onClick={() => triggerDelete("services", s.id, s.name)}
                      className="text-red-400 hover:text-red-600 bg-red-50 hover:bg-red-100 p-2 rounded-lg transition-colors"
                    >
                      <Trash2 size={18} />
                    </button>
                  </div>
                  <div className="p-4 md:p-5">
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 mb-4">
                      {rooms
                        .filter((r) => r.serviceId === s.id)
                        .map((r) => (
                          <div
                            key={r.id}
                            className="flex justify-between items-center p-3 border border-indigo-100 rounded-xl bg-indigo-50/50 hover:bg-indigo-50"
                          >
                            <span className="font-medium text-slate-700 text-sm flex items-center gap-2 truncate">
                              <DoorOpen
                                size={16}
                                className="text-indigo-400 shrink-0"
                              />{" "}
                              {r.name}
                            </span>
                            <button
                              onClick={() =>
                                triggerDelete("rooms", r.id, r.name)
                              }
                              className="text-red-400 hover:text-red-600 p-1.5 bg-white rounded-md shadow-sm border border-slate-100 shrink-0"
                            >
                              <Trash2 size={14} />
                            </button>
                          </div>
                        ))}
                      {rooms.filter((r) => r.serviceId === s.id).length ===
                        0 && (
                        <div className="text-sm text-slate-400 font-medium italic p-4 border border-dashed rounded-xl text-center col-span-full">
                          Sin espacios asignados.
                        </div>
                      )}
                    </div>
                    <form
                      onSubmit={(e) => handleAddRoomSpecific(e, s.id)}
                      className="flex flex-col sm:flex-row gap-2"
                    >
                      <input
                        type="text"
                        value={newRoomNames[s.id] || ""}
                        onChange={(e) =>
                          handleRoomNameChange(s.id, e.target.value)
                        }
                        className="flex-1 p-3 text-sm border border-slate-300 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none bg-slate-50"
                        placeholder={`Ej. Consultorio 1...`}
                        required
                      />
                      <button
                        type="submit"
                        className="bg-indigo-600 text-white px-5 py-3 rounded-xl font-bold hover:bg-indigo-700 text-sm flex items-center justify-center gap-2"
                      >
                        <Plus size={16} /> Añadir
                      </button>
                    </form>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}

      {activeTab === "system" && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 animate-fade-in flex-1 overflow-y-auto">
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200">
            <h3 className="text-xl font-bold mb-4 text-slate-800 flex items-center gap-2">
              <Type className="text-indigo-600" /> Textos de Inicio
            </h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-bold text-slate-700 mb-1">
                  Título Principal
                </label>
                <input
                  type="text"
                  value={globalSettings.welcomeTitle || ""}
                  onChange={(e) =>
                    updateGlobalSettings({ welcomeTitle: e.target.value })
                  }
                  placeholder="Ej. Centro Oncológico..."
                  className="w-full p-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none"
                />
              </div>
              <div>
                <label className="block text-sm font-bold text-slate-700 mb-1">
                  Mensaje de Bienvenida
                </label>
                <textarea
                  value={globalSettings.welcomeMessage || ""}
                  onChange={(e) =>
                    updateGlobalSettings({ welcomeMessage: e.target.value })
                  }
                  className="w-full p-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none resize-none h-24"
                />
              </div>
            </div>
            <div className="mt-6 border-t pt-4">
              <h3 className="text-sm font-bold mb-2 text-slate-800 flex items-center gap-2">
                <ImageIcon className="text-blue-500" size={16} /> Logo
              </h3>
              <label className="cursor-pointer bg-blue-50 text-blue-700 px-4 py-2 rounded-xl font-bold hover:bg-blue-100 transition-colors border border-blue-200 w-full inline-block text-center text-sm">
                Subir Imagen (Máx 200kb)
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleLogoUpload}
                  className="hidden"
                />
              </label>
              {logoError && (
                <p className="mt-2 text-xs text-red-600 font-bold text-center bg-red-50 p-2 rounded">
                  {logoError}
                </p>
              )}
              {globalSettings.logoUrl && (
                <button
                  onClick={() => updateGlobalSettings({ logoUrl: null })}
                  className="mt-2 text-xs text-red-500 font-bold block text-center w-full"
                >
                  Quitar Logo Actual
                </button>
              )}
            </div>
          </div>

          <div className="space-y-6">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-red-200 border-l-4 border-l-red-500">
              <h3 className="text-xl font-bold mb-2 text-slate-800 flex items-center gap-2">
                <Lock className="text-red-500" /> Seguridad (PIN por Módulo)
              </h3>
              <p className="text-sm text-slate-500 mb-4">
                Establece un PIN numérico independiente para cada área. Déjalo
                en blanco para dejar el módulo libre.
              </p>
              <div className="space-y-3 mt-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center shrink-0">
                    <Settings size={18} className="text-slate-600" />
                  </div>
                  <div className="flex-1">
                    <input
                      type="password"
                      value={globalSettings.adminPin || ""}
                      onChange={(e) =>
                        updateGlobalSettings({ adminPin: e.target.value })
                      }
                      placeholder="PIN Admin"
                      className="w-full p-2 text-center tracking-widest border border-slate-300 rounded-lg focus:ring-2 focus:ring-red-500 outline-none"
                    />
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-emerald-50 flex items-center justify-center shrink-0">
                    <CalendarDays size={18} className="text-emerald-600" />
                  </div>
                  <div className="flex-1">
                    <input
                      type="password"
                      value={globalSettings.agendaPin || ""}
                      onChange={(e) =>
                        updateGlobalSettings({ agendaPin: e.target.value })
                      }
                      placeholder="PIN Agenda"
                      className="w-full p-2 text-center tracking-widest border border-emerald-300 rounded-lg focus:ring-2 focus:ring-emerald-500 outline-none"
                    />
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-indigo-50 flex items-center justify-center shrink-0">
                    <Volume1 size={18} className="text-indigo-600" />
                  </div>
                  <div className="flex-1">
                    <input
                      type="password"
                      value={globalSettings.staffPin || ""}
                      onChange={(e) =>
                        updateGlobalSettings({ staffPin: e.target.value })
                      }
                      placeholder="PIN Staff"
                      className="w-full p-2 text-center tracking-widest border border-indigo-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none"
                    />
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-amber-50 flex items-center justify-center shrink-0">
                    <UserCog size={18} className="text-amber-600" />
                  </div>
                  <div className="flex-1">
                    <input
                      type="password"
                      value={globalSettings.orientadorPin || ""}
                      onChange={(e) =>
                        updateGlobalSettings({ orientadorPin: e.target.value })
                      }
                      placeholder="PIN Orientador"
                      className="w-full p-2 text-center tracking-widest border border-amber-300 rounded-lg focus:ring-2 focus:ring-amber-500 outline-none"
                    />
                  </div>
                </div>
              </div>
              <div className="mt-6 pt-4 border-t border-red-100">
                <label className="text-xs font-bold text-slate-800 uppercase block mb-1">
                  Palabra Maestra de Recuperación
                </label>
                <input
                  type="text"
                  value={globalSettings.masterPassword || "admin"}
                  onChange={(e) =>
                    updateGlobalSettings({ masterPassword: e.target.value })
                  }
                  className="w-full p-2 border border-red-200 bg-red-50 rounded-lg focus:ring-2 focus:ring-red-500 outline-none font-bold text-slate-700"
                />
              </div>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200">
              <h3 className="text-xl font-bold mb-2 text-slate-800 flex items-center gap-2">
                <Video className="text-teal-600" /> Cartelera Pantalla TV
              </h3>
              <input
                type="text"
                value={globalSettings.mediaUrl || ""}
                onChange={(e) =>
                  updateGlobalSettings({ mediaUrl: e.target.value })
                }
                placeholder="URL YouTube Embed (Ej. https://youtube.com/watch?v=...)"
                className="w-full p-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-teal-500 outline-none mb-4 text-sm"
              />
              <input
                type="text"
                value={globalSettings.tvMarquee || ""}
                onChange={(e) =>
                  updateGlobalSettings({ tvMarquee: e.target.value })
                }
                placeholder="Marquesina Inferior..."
                className="w-full p-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-teal-500 outline-none text-sm"
              />
            </div>
          </div>

          <div className="bg-purple-50 p-6 rounded-2xl shadow-sm border border-purple-200 flex flex-col justify-center items-center text-center md:col-span-2">
            <h3 className="text-xl font-bold mb-2 text-purple-800 flex items-center gap-2">
              <Star className="fill-purple-800" /> Datos de Prueba
            </h3>
            <button
              onClick={generateDemoData}
              disabled={demoStatus?.type === "loading"}
              className={`text-white px-8 py-3 rounded-xl font-bold transition-all shadow-lg flex items-center justify-center gap-2 w-full sm:w-auto ${
                demoStatus?.type === "loading"
                  ? "bg-purple-400 cursor-wait"
                  : "bg-purple-600 hover:bg-purple-700"
              }`}
            >
              <RefreshCw
                size={20}
                className={demoStatus?.type === "loading" ? "animate-spin" : ""}
              />{" "}
              {demoStatus?.type === "loading"
                ? "Generando..."
                : "Generar Turnos Demo"}
            </button>
          </div>

          <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200 md:col-span-2">
            <h3 className="text-xl font-bold mb-2 text-slate-800 flex items-center gap-2">
              <Settings className="text-slate-600" /> Diagnóstico de BD Atómica
            </h3>
            <div className="flex flex-col md:flex-row gap-4 items-start">
              <button
                onClick={runSystemTest}
                disabled={testResult?.status === "running"}
                className={`px-6 py-3 rounded-xl font-bold transition-all shadow-md flex items-center justify-center gap-2 text-white w-full md:w-auto ${
                  testResult?.status === "running"
                    ? "bg-slate-400 cursor-wait"
                    : "bg-slate-800 hover:bg-slate-900"
                }`}
              >
                {testResult?.status === "running" ? (
                  <RefreshCw size={20} className="animate-spin" />
                ) : (
                  <MonitorPlay size={20} />
                )}{" "}
                {testResult?.status === "running"
                  ? "Ejecutando..."
                  : "Iniciar Test"}
              </button>
              {testResult && testResult.status !== "running" && (
                <div
                  className={`flex-1 w-full p-4 rounded-xl border ${
                    testResult.status === "success"
                      ? "bg-green-50 border-green-200"
                      : "bg-red-50 border-red-200"
                  }`}
                >
                  <div
                    className={`font-bold mb-2 flex items-center gap-2 ${
                      testResult.status === "success"
                        ? "text-green-700"
                        : "text-red-700"
                    }`}
                  >
                    {testResult.status === "success" ? (
                      <CheckCircle size={20} className="shrink-0" />
                    ) : (
                      <AlertTriangle size={20} className="shrink-0" />
                    )}{" "}
                    {testResult.status === "success"
                      ? "Sistema Atómico OK."
                      : "Errores de Transacción."}
                  </div>
                  {testResult.status === "error" && (
                    <textarea
                      readOnly
                      value={testResult.errorDetails}
                      className="w-full h-32 p-3 text-sm font-mono bg-white border border-red-200 rounded-lg text-red-600 mb-3 outline-none resize-none"
                    />
                  )}
                  <button
                    onClick={downloadTestReport}
                    className="text-sm font-bold bg-white px-4 py-2 rounded-lg shadow-sm border border-slate-200 hover:bg-slate-50 flex items-center justify-center w-full sm:w-auto gap-2 text-slate-700 mt-2"
                  >
                    <FileText size={16} /> Exportar TXT
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {activeTab === "history" && (
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 flex flex-col flex-1 min-h-0 animate-fade-in">
          <div className="p-4 border-b border-slate-200 flex flex-col sm:flex-row gap-4 items-start sm:items-end justify-between bg-slate-50 rounded-t-2xl">
            <div className="w-full sm:w-auto">
              <label className="block text-sm font-bold text-slate-700 mb-1 flex items-center gap-2">
                <Calendar size={16} /> Búsqueda Histórica
              </label>
              <input
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                className="p-2 border border-slate-300 rounded-lg focus:ring-2 font-medium text-slate-700 w-full sm:w-48 outline-none"
              />
            </div>
            <button
              onClick={downloadHistoryTXT}
              className="w-full sm:w-auto bg-slate-800 text-white px-5 py-2.5 rounded-xl font-bold hover:bg-slate-900 flex justify-center items-center gap-2 text-sm shadow"
            >
              <FileText size={18} /> Exportar TXT
            </button>
          </div>
          <div className="p-0 flex-1 overflow-auto relative">
            {isLoadingHistory && (
              <div className="absolute inset-0 bg-white/70 backdrop-blur-sm z-10 flex items-center justify-center">
                <Loader2 className="animate-spin text-teal-600" size={40} />
              </div>
            )}

            <div className="min-w-[800px]">
              <table className="w-full text-left border-collapse text-sm">
                <thead>
                  <tr className="bg-slate-100 text-slate-600 uppercase tracking-wider sticky top-0 shadow-sm">
                    <th className="p-4 border-b">Turno</th>
                    <th className="p-4 border-b">Paciente</th>
                    <th className="p-4 border-b">Área</th>
                    <th className="p-4 border-b">Trazabilidad</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {[...historyTickets]
                    .sort((a, b) => b.timestamp - a.timestamp)
                    .map((t) => (
                      <tr key={t.id} className="hover:bg-slate-50">
                        <td className="p-4">
                          <div className="font-black text-slate-800 text-lg">
                            {t.number}
                          </div>
                          <div className="text-xs text-slate-500">
                            {t.sedeName}
                          </div>
                        </td>
                        <td className="p-4">
                          <div className="font-bold text-slate-700">
                            {t.name} {t.apellidos}
                          </div>
                          <div className="text-xs text-slate-500">
                            CC: {t.cedula}
                          </div>
                        </td>
                        <td className="p-4">
                          <span className="font-medium text-slate-700">
                            {t.serviceName}
                          </span>
                        </td>
                        <td className="p-4">
                          <div className="text-xs font-bold mb-1">
                            {t.status.toUpperCase()}
                          </div>
                          <div className="text-xs text-slate-500">
                            Llegada:{" "}
                            {new Date(t.timestamp).toLocaleTimeString()}{" "}
                            {t.calledAt &&
                              `| Llamado: ${new Date(
                                t.calledAt
                              ).toLocaleTimeString()}`}
                          </div>
                          {t.staffNote && (
                            <div className="mt-1 text-xs bg-slate-100 p-1.5 rounded italic break-words whitespace-pre-wrap">
                              {t.staffNote}
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
                  {historyTickets.length === 0 && !isLoadingHistory && (
                    <tr>
                      <td
                        colSpan="4"
                        className="text-center p-8 text-slate-400 font-medium"
                      >
                        Busque una fecha para ver el historial.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ============================================================================
// MÓDULO: AGENDAMIENTO
// ============================================================================
function AgendaView({
  sedes,
  epsList,
  services,
  staffList,
  appointments,
  addEntityToDb,
  updateAppointmentStatus,
  showToast,
}) {
  const [activeDate, setActiveDate] = useState(getLocalDateString());
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState({ show: false, id: null });

  const [formData, setFormData] = useState({
    cedula: "",
    name: "",
    apellidos: "",
    celular: "",
    eps: "",
    sedeId: sedes[0]?.id || "",
    serviceId: "",
    staffId: "",
    date: getLocalDateString(),
    time: "08:00",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "serviceId" ? { staffId: "" } : {}),
    }));
  };

  const handleCreateAppointment = async (e) => {
    e.preventDefault();
    if (
      !formData.cedula ||
      !formData.name ||
      !formData.serviceId ||
      !formData.date ||
      !formData.time
    )
      return;

    const hasConflict = appointments.some(
      (a) =>
        a.date === formData.date &&
        a.time === formData.time &&
        a.staffId === formData.staffId &&
        a.staffId !== "" &&
        a.status !== "cancelled"
    );
    if (hasConflict) {
      showToast(
        "Error: Ya existe una cita a esta misma hora con este profesional.",
        "error"
      );
      return;
    }

    const serviceInfo = services.find((s) => s.id === formData.serviceId);
    const staffInfo = staffList.find((s) => s.id === formData.staffId);
    const sedeInfo = sedes.find((s) => s.id === formData.sedeId);
    await addEntityToDb("appointments", {
      id: Date.now().toString(),
      ...formData,
      serviceName: serviceInfo?.name || "",
      staffName: staffInfo ? `${staffInfo.name} ${staffInfo.apellidos}` : null,
      sedeName: sedeInfo?.name || "",
      status: "pending",
      createdAt: Date.now(),
    });
    setIsFormOpen(false);
    setFormData({
      ...formData,
      cedula: "",
      name: "",
      apellidos: "",
      celular: "",
      time: "08:00",
    });
  };

  const executeDelete = async () => {
    if (confirmDelete.id) {
      await updateAppointmentStatus(confirmDelete.id, { status: "cancelled" });
      showToast("Cita cancelada (Soft Delete)", "success");
    }
    setConfirmDelete({ show: false, id: null });
  };

  const filteredAppointments = [...appointments]
    .filter((a) => a.date === activeDate)
    .sort((a, b) => a.time.localeCompare(b.time));
  const sedeServices = services.filter((s) => s.sedeId === formData.sedeId);

  return (
    <div className="p-4 md:p-6 max-w-7xl mx-auto h-full flex flex-col relative">
      {confirmDelete.show && (
        <div className="absolute inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4 rounded-xl">
          <div className="bg-white p-6 rounded-2xl shadow-2xl max-w-sm w-full">
            <h3 className="text-xl font-bold mb-4 text-red-600">
              Cancelar Cita
            </h3>
            <p className="text-slate-600 mb-6">
              ¿Estás seguro de cancelar esta cita? Quedará registrada como
              cancelada.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={() => setConfirmDelete({ show: false, id: null })}
                className="flex-1 py-3 sm:py-2 bg-slate-100 font-bold rounded-xl hover:bg-slate-200"
              >
                Atrás
              </button>
              <button
                onClick={executeDelete}
                className="flex-1 py-3 sm:py-2 bg-red-600 text-white font-bold rounded-xl hover:bg-red-700"
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}

      {isFormOpen && (
        <div className="absolute inset-0 z-40 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 overflow-y-auto">
          <div className="bg-white rounded-3xl shadow-2xl w-full max-w-2xl my-8 animate-pop-in flex flex-col max-h-[90vh]">
            <div className="p-4 md:p-5 border-b border-slate-200 flex justify-between items-center bg-emerald-50 rounded-t-3xl">
              <h2 className="text-lg md:text-xl font-bold text-emerald-800 flex items-center gap-2">
                <CalendarPlus size={24} /> Nueva Cita
              </h2>
              <button
                onClick={() => setIsFormOpen(false)}
                className="text-slate-400 hover:text-slate-700 p-1 bg-white rounded-full"
              >
                <Trash2 size={20} className="hidden" />
              </button>
            </div>
            <form
              onSubmit={handleCreateAppointment}
              className="p-4 md:p-6 space-y-4 overflow-y-auto"
            >
              <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-2 border-b pb-1">
                Datos del Paciente
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-bold text-slate-700 mb-1">
                    Cédula *
                  </label>
                  <input
                    type="number"
                    name="cedula"
                    value={formData.cedula}
                    onChange={handleInputChange}
                    className="w-full p-2.5 border border-slate-300 rounded-xl focus:ring-2 focus:ring-emerald-500 outline-none"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-bold text-slate-700 mb-1">
                    Nombres *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="w-full p-2.5 border border-slate-300 rounded-xl focus:ring-2 focus:ring-emerald-500 outline-none"
                    required
                  />
                </div>
              </div>
              <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-2 mt-4 border-b pb-1">
                Detalles de la Cita
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-bold text-slate-700 mb-1">
                    Área / Servicio *
                  </label>
                  <select
                    name="serviceId"
                    value={formData.serviceId}
                    onChange={handleInputChange}
                    className="w-full p-2.5 border border-slate-300 rounded-xl focus:ring-2 outline-none cursor-pointer"
                    required
                  >
                    <option value="">-- Seleccionar --</option>
                    {sedeServices.map((s) => (
                      <option key={s.id} value={s.id}>
                        {s.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-bold text-slate-700 mb-1">
                    Médico (Opcional)
                  </label>
                  <select
                    name="staffId"
                    value={formData.staffId}
                    onChange={handleInputChange}
                    disabled={!formData.serviceId}
                    className="w-full p-2.5 border border-slate-300 rounded-xl focus:ring-2 outline-none cursor-pointer disabled:bg-slate-100 disabled:opacity-60"
                  >
                    <option value="">Cualquiera</option>
                    {staffList
                      .filter((s) => s.serviceId === formData.serviceId)
                      .map((staff) => (
                        <option key={staff.id} value={staff.id}>
                          Dr. {staff.name}
                        </option>
                      ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-bold text-slate-700 mb-1">
                    Fecha *
                  </label>
                  <input
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={handleInputChange}
                    className="w-full p-2.5 border border-slate-300 rounded-xl focus:ring-2 outline-none cursor-pointer"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-bold text-slate-700 mb-1">
                    Hora *
                  </label>
                  <input
                    type="time"
                    name="time"
                    value={formData.time}
                    onChange={handleInputChange}
                    className="w-full p-2.5 border border-slate-300 rounded-xl focus:ring-2 outline-none cursor-pointer"
                    required
                  />
                </div>
              </div>
              <div className="flex flex-col sm:flex-row justify-end gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => setIsFormOpen(false)}
                  className="w-full sm:w-auto px-6 py-3 bg-slate-100 text-slate-700 font-bold rounded-xl text-center"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="w-full sm:w-auto px-8 py-3 bg-emerald-600 text-white font-bold rounded-xl shadow-lg hover:bg-emerald-700 flex justify-center items-center gap-2"
                >
                  Guardar Cita
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4 border-b border-slate-300 pb-4">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-slate-800 flex items-center gap-2">
            <CalendarDays className="text-emerald-600" /> Agendamiento
          </h2>
        </div>
        <button
          onClick={() => setIsFormOpen(true)}
          className="w-full sm:w-auto bg-emerald-600 text-white px-5 py-3 rounded-xl font-bold hover:bg-emerald-700 shadow-md flex justify-center items-center gap-2"
        >
          <CalendarPlus size={20} /> Agendar
        </button>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 flex-1 flex flex-col min-h-0 overflow-hidden">
        <div className="p-4 border-b border-slate-200 bg-slate-50 flex justify-between items-center">
          <input
            type="date"
            value={activeDate}
            onChange={(e) => setActiveDate(e.target.value)}
            className="w-full sm:w-auto p-2 border border-slate-300 rounded-lg outline-none font-bold text-emerald-700"
          />
          <div className="hidden sm:block text-sm font-bold text-slate-500">
            Citas: {filteredAppointments.length}
          </div>
        </div>
        <div className="flex-1 overflow-y-auto p-4 bg-slate-50/50">
          <div className="grid gap-3">
            {filteredAppointments.map((app) => (
              <div
                key={app.id}
                className={`flex flex-col sm:flex-row bg-white border rounded-xl p-4 items-start sm:items-center gap-4 ${
                  app.status === "arrived"
                    ? "border-emerald-300 bg-emerald-50"
                    : app.status === "cancelled"
                    ? "opacity-50"
                    : "border-slate-200"
                }`}
              >
                <div className="bg-slate-100 p-2 sm:p-3 rounded-lg text-center w-full sm:w-auto sm:min-w-[70px] flex sm:flex-col items-center justify-center gap-2 sm:gap-0">
                  <Clock size={16} className="text-slate-400 sm:mb-1" />
                  <div className="font-black text-slate-800">{app.time}</div>
                </div>
                <div className="flex-1 w-full">
                  <div className="font-bold text-lg leading-tight">
                    {app.name} {app.apellidos}{" "}
                    {app.status === "cancelled" && (
                      <span className="text-xs text-red-500 ml-2">
                        (Cancelada)
                      </span>
                    )}
                  </div>
                  <div className="text-sm text-slate-500 mt-1">
                    CC: {app.cedula} • {app.serviceName}
                  </div>
                </div>
                {app.status === "pending" && (
                  <div className="flex gap-2 w-full sm:w-auto justify-end border-t sm:border-t-0 pt-3 sm:pt-0 mt-2 sm:mt-0">
                    <button
                      onClick={() => {
                        updateAppointmentStatus(app.id, { status: "arrived" });
                        showToast("Cita marcada como Llegó");
                      }}
                      className="px-4 sm:px-3 py-2 bg-emerald-100 text-emerald-700 rounded-lg font-bold hover:bg-emerald-200"
                    >
                      Llegó
                    </button>
                    <button
                      onClick={() =>
                        setConfirmDelete({ show: true, id: app.id })
                      }
                      className="px-4 sm:px-2 py-2 text-red-500 bg-red-50 sm:bg-transparent hover:bg-red-100 rounded-lg"
                    >
                      <Trash2 size={18} className="mx-auto" />
                    </button>
                  </div>
                )}
              </div>
            ))}
            {filteredAppointments.length === 0 && (
              <div className="text-center p-8 text-slate-400">
                No hay citas para esta fecha.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

// ============================================================================
// MÓDULO: KIOSCO
// ============================================================================
function KioskView({
  user,
  db,
  appId,
  sedes,
  epsList,
  services,
  counters,
  saveTicket,
  updateCounter,
  globalSettings,
  staffList,
  appointments,
  updateAppointmentStatus,
  showToast,
}) {
  const [activeSedeId, setActiveSedeId] = useState("");
  const [kioskPhase, setKioskPhase] = useState("search");
  const [searchCedula, setSearchCedula] = useState("");
  const [foundAppt, setFoundAppt] = useState(null);
  const [foundAppts, setFoundAppts] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    apellidos: "",
    cedula: "",
    celular: "",
    correo: "",
    eps: "",
    isPriority: false,
    appointmentTime: "",
    serviceId: "",
    staffId: "",
  });
  const [generatedTicket, setGeneratedTicket] = useState(null);

  const changeSede = (id) => {
    setActiveSedeId(id);
    localStorage.setItem("dt_kiosk_sede", id);
    resetKiosk();
  };

  const resetKiosk = () => {
    setKioskPhase("search");
    setSearchCedula("");
    setFoundAppt(null);
    setFoundAppts([]);
    setFormData({
      name: "",
      apellidos: "",
      cedula: "",
      celular: "",
      correo: "",
      eps: "",
      isPriority: false,
      appointmentTime: "",
      serviceId: "",
      staffId: "",
    });
    setGeneratedTicket(null);
    setIsProcessing(false);
  };

  const handleSearchCedula = async (e) => {
    e.preventDefault();
    if (!searchCedula.trim()) return;
    setIsProcessing(true);
    const todayStr = getLocalDateString();

    const pendingAppts = [...appointments].filter(
      (a) =>
        a.cedula === searchCedula.trim() &&
        a.date === todayStr &&
        a.sedeId === activeSedeId &&
        a.status === "pending"
    );

    if (pendingAppts.length === 1) {
      setFoundAppt(pendingAppts[0]);
      setKioskPhase("found");
    } else if (pendingAppts.length > 1) {
      setFoundAppts(pendingAppts);
      setKioskPhase("found_multiple");
    } else {
      try {
        const q = query(
          collection(db, `artifacts/${appId}/public/data/tickets`),
          where("cedula", "==", searchCedula.trim())
        );
        const snap = await getDocs(q);
        let pastRecord = null;
        if (!snap.empty) {
          const pastTickets = snap.docs
            .map((d) => d.data())
            .sort((a, b) => b.timestamp - a.timestamp);
          pastRecord = pastTickets[0];
        }
        setFormData((prev) => ({
          ...prev,
          cedula: searchCedula.trim(),
          name: pastRecord?.name || "",
          apellidos: pastRecord?.apellidos || "",
          celular: pastRecord?.celular || "",
          correo: pastRecord?.correo || "",
          eps: pastRecord?.eps || "",
        }));
      } catch (err) {
        setFormData((prev) => ({ ...prev, cedula: searchCedula.trim() }));
      }
      setKioskPhase("form");
    }
    setIsProcessing(false);
  };

  const handleGenerateFromAppointment = async () => {
    if (!foundAppt) return;
    const service = services.find((s) => s.id === foundAppt.serviceId);
    const staff = staffList.find((s) => s.id === foundAppt.staffId) || null;
    const fastTrackData = {
      name: foundAppt.name,
      apellidos: foundAppt.apellidos || "",
      cedula: foundAppt.cedula,
      celular: foundAppt.celular || "",
      correo: "",
      eps: foundAppt.eps || "Particular",
      isPriority: false,
      appointmentTime: foundAppt.time,
    };

    await updateAppointmentStatus(foundAppt.id, { status: "arrived" });
    if (service) {
      await generateTicketAtomic(service, staff, fastTrackData);
    } else {
      setKioskPhase("form");
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const service = services.find((s) => s.id === formData.serviceId);
    const staff = staffList.find((s) => s.id === formData.staffId) || null;
    if (service) generateTicketAtomic(service, staff, formData);
  };

  const generateTicketAtomic = async (service, staff = null, dataToUse) => {
    setIsProcessing(true);
    if (!user || !db) return;
    try {
      const counterRef = doc(
        db,
        `artifacts/${appId}/public/data/counters`,
        service.id
      );
      const newTicketId = Date.now().toString();
      const ticketRef = doc(
        db,
        `artifacts/${appId}/public/data/tickets`,
        newTicketId
      );
      const sedeInfo = sedes.find((s) => s.id === activeSedeId) || sedes[0];

      const createdTicket = await runTransaction(db, async (transaction) => {
        const counterDoc = await transaction.get(counterRef);
        const currentCount = counterDoc.exists() ? counterDoc.data().count : 0;
        const nextCount = currentCount + 1;
        const ticketNumber = `${service.prefix}-${nextCount
          .toString()
          .padStart(3, "0")}`;

        const newTicket = {
          id: newTicketId,
          number: ticketNumber,
          sedeId: sedeInfo.id,
          sedeName: sedeInfo.name,
          serviceId: service.id,
          serviceName: service.name,
          floor: service.floor || "1",
          name: dataToUse.name.trim(),
          apellidos: dataToUse.apellidos?.trim() || "",
          cedula: dataToUse.cedula.trim(),
          celular: dataToUse.celular?.trim() || "",
          correo: dataToUse.correo?.trim() || "",
          eps: dataToUse.eps,
          priority: dataToUse.isPriority,
          appointmentTime: dataToUse.appointmentTime,
          status: "waiting",
          roomId: null,
          staffId: staff ? staff.id : null,
          staffName: staff ? `${staff.name} ${staff.apellidos}` : null,
          staffNote: "",
          timestamp: Date.now(),
          calledAt: null,
          finishedAt: null,
          dateString: getLocalDateString(),
        };
        transaction.set(counterRef, { count: nextCount });
        transaction.set(ticketRef, newTicket);
        return newTicket;
      });

      setGeneratedTicket(createdTicket);
      setKioskPhase("ticket");
      showToast("Turno generado con éxito", "success");
      setTimeout(() => {
        if (document.visibilityState === "visible") resetKiosk();
      }, 12000);
    } catch (e) {
      showToast("Error al generar turno. Reintente.", "error");
      setKioskPhase("form");
    }
    setIsProcessing(false);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => {
      const newData = {
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      };
      if (name === "serviceId") newData.staffId = "";
      return newData;
    });
  };

  useEffect(() => {
    const savedSede = localStorage.getItem("dt_kiosk_sede");
    if (savedSede && sedes.find((s) => s.id === savedSede))
      setActiveSedeId(savedSede);
    else if (sedes.length > 0) setActiveSedeId(sedes[0].id);
  }, [sedes]);
  useEffect(() => {
    let timer;
    const resetTimer = () => {
      clearTimeout(timer);
      if (kioskPhase !== "ticket") {
        timer = setTimeout(() => resetKiosk(), 60000);
      }
    };
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("touchstart", resetTimer);
    resetTimer();
    return () => {
      clearTimeout(timer);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("touchstart", resetTimer);
    };
  }, [kioskPhase]);

  const sedeServices = services.filter((s) => s.sedeId === activeSedeId);

  return (
    <div className="h-full flex flex-col bg-slate-50 relative print:bg-white overflow-y-auto">
      <div className="absolute top-4 right-4 z-10 flex items-center gap-2 bg-white px-3 md:px-4 py-2 rounded-full shadow border border-slate-200 print:hidden">
        <MapPin size={16} className="text-teal-600" />
        <select
          value={activeSedeId}
          onChange={(e) => changeSede(e.target.value)}
          className="text-xs md:text-sm font-bold text-slate-700 outline-none bg-transparent cursor-pointer max-w-[100px] md:max-w-none"
        >
          {sedes.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
        </select>
      </div>

      <div className="bg-white p-4 md:p-6 text-center shadow-sm border-b-4 border-teal-600 flex flex-col items-center justify-center print:hidden shrink-0 mt-14 md:mt-0">
        {globalSettings.logoUrl && (
          <img
            src={globalSettings.logoUrl}
            alt="Logo"
            className="h-10 md:h-16 object-contain mb-2"
          />
        )}
        <h1 className="text-xl md:text-3xl font-black text-slate-800">
          TOMA DE TURNOS
        </h1>
      </div>

      <div className="flex-1 flex items-center justify-center p-4 print:p-0">
        {kioskPhase === "search" && (
          <div className="w-full max-w-xl bg-white p-6 md:p-10 rounded-3xl shadow-xl border border-slate-200 animate-fade-in text-center">
            <div className="bg-teal-50 w-16 h-16 md:w-24 md:h-24 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6 shadow-inner">
              <Search className="text-teal-600 w-8 h-8 md:w-10 md:h-10" />
            </div>
            <h2 className="text-2xl md:text-3xl font-black text-slate-800 mb-2">
              Bienvenido
            </h2>
            <p className="text-slate-500 text-sm md:text-lg mb-6 md:mb-8">
              Por favor, ingrese su documento de identidad.
            </p>
            <form
              onSubmit={handleSearchCedula}
              className="space-y-4 md:space-y-6"
            >
              <input
                type="number"
                value={searchCedula}
                onChange={(e) => setSearchCedula(e.target.value)}
                placeholder="Ej. 10203040"
                className="w-full p-4 md:p-5 text-center text-3xl md:text-4xl font-black tracking-widest border-2 border-slate-300 rounded-2xl focus:border-teal-500 outline-none"
                autoFocus
                required
              />
              <button
                type="submit"
                disabled={isProcessing}
                className={`w-full py-4 md:py-5 text-xl md:text-2xl font-bold text-white bg-teal-600 rounded-2xl shadow-lg flex items-center justify-center gap-3 transition-all ${
                  isProcessing ? "opacity-70" : "hover:-translate-y-1"
                }`}
              >
                {isProcessing ? (
                  <Loader2 className="animate-spin" size={28} />
                ) : (
                  "Continuar"
                )}
              </button>
            </form>
          </div>
        )}

        {kioskPhase === "found_multiple" && foundAppts.length > 0 && (
          <div className="w-full max-w-4xl bg-white p-6 md:p-10 rounded-3xl shadow-2xl border-2 border-emerald-400 animate-pop-in text-center relative overflow-y-auto max-h-[90vh]">
            <button
              onClick={resetKiosk}
              className="absolute top-4 left-4 md:top-6 md:left-6 text-slate-500 bg-slate-100 px-3 py-2 md:px-4 md:py-2 rounded-xl text-xs md:text-sm font-bold flex items-center gap-2 z-20"
            >
              <CornerUpLeft size={16} /> Volver
            </button>
            <h2 className="text-2xl md:text-3xl font-black text-slate-800 mb-2 mt-12 md:mt-8">
              Citas para Hoy
            </h2>
            <p className="text-slate-500 text-sm md:text-base mb-6">
              Selecciona a cuál deseas ingresar en este momento.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 text-left">
              {foundAppts.map((appt) => (
                <button
                  key={appt.id}
                  onClick={() => {
                    setFoundAppt(appt);
                    setKioskPhase("found");
                  }}
                  className="bg-slate-50 border border-slate-200 hover:border-emerald-500 p-4 md:p-6 rounded-2xl text-left shadow-sm"
                >
                  <div className="text-lg md:text-xl font-black text-slate-800">
                    {appt.time}
                  </div>
                  <div className="text-emerald-700 font-bold mt-1 text-sm md:text-base">
                    {appt.serviceName}
                  </div>
                  <div className="text-xs md:text-sm mt-1 text-slate-500">
                    <UserCircle className="inline mr-1 w-4 h-4" />{" "}
                    {appt.staffName || "General"}
                  </div>
                </button>
              ))}
            </div>
            <button
              onClick={() => {
                setFormData((prev) => ({
                  ...prev,
                  cedula: foundAppts[0].cedula,
                  name: foundAppts[0].name,
                  apellidos: foundAppts[0].apellidos || "",
                }));
                setKioskPhase("form");
              }}
              className="w-full py-4 font-bold text-slate-600 bg-white border-2 border-slate-200 rounded-2xl text-sm md:text-base"
            >
              Requiero un turno para otra área
            </button>
          </div>
        )}

        {kioskPhase === "found" && foundAppt && (
          <div className="w-full max-w-2xl bg-white p-6 md:p-10 rounded-3xl shadow-2xl border-2 border-emerald-400 animate-pop-in text-center relative overflow-y-auto max-h-[90vh]">
            <button
              onClick={resetKiosk}
              className="absolute top-4 left-4 md:top-6 md:left-6 text-slate-500 bg-slate-100 px-3 py-2 md:px-4 md:py-2 rounded-xl text-xs md:text-sm font-bold flex items-center gap-2 z-20"
            >
              <CornerUpLeft size={16} /> Volver
            </button>
            <div className="bg-emerald-100 text-emerald-700 px-4 py-1 rounded-full inline-flex font-bold text-xs md:text-sm mb-4 mt-12 md:mt-8">
              ¡Cita Encontrada!
            </div>
            <h2 className="text-2xl md:text-4xl font-black text-slate-800 mb-6">
              Hola, {foundAppt.name}
            </h2>
            <div className="bg-slate-50 border border-slate-200 p-4 md:p-6 rounded-2xl text-left space-y-3 md:space-y-4 mb-6 md:mb-8">
              <div className="font-bold text-base md:text-lg text-slate-800">
                <Clock className="inline mr-2 text-emerald-600" />{" "}
                {foundAppt.time} - {foundAppt.serviceName}
              </div>
              {foundAppt.staffName && (
                <div className="text-sm md:text-base text-slate-600">
                  <UserCircle className="inline mr-2" /> {foundAppt.staffName}
                </div>
              )}
            </div>
            <div className="space-y-3">
              <button
                onClick={handleGenerateFromAppointment}
                disabled={isProcessing}
                className="w-full py-4 md:py-5 text-lg md:text-xl font-bold text-white bg-emerald-600 rounded-2xl shadow-lg flex justify-center items-center gap-3"
              >
                {isProcessing ? (
                  <Loader2 className="animate-spin" />
                ) : (
                  "Confirmar Llegada"
                )}
              </button>
              <button
                onClick={() => {
                  setFormData((prev) => ({
                    ...prev,
                    cedula: foundAppt.cedula,
                    name: foundAppt.name,
                    apellidos: foundAppt.apellidos || "",
                  }));
                  setKioskPhase("form");
                }}
                className="w-full py-3 md:py-4 text-slate-600 bg-white border-2 border-slate-200 rounded-2xl font-bold text-sm md:text-base"
              >
                Requiero turno para otra área
              </button>
            </div>
          </div>
        )}

        {kioskPhase === "form" && (
          <div className="w-full max-w-4xl bg-white p-6 md:p-8 rounded-3xl shadow-xl border border-slate-200 animate-fade-in overflow-y-auto max-h-[90vh]">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-6 gap-4">
              <h2 className="text-xl md:text-2xl font-bold text-slate-800 flex items-center gap-2">
                <UserPlus className="text-teal-600" /> Toma Manual
              </h2>
              <button
                onClick={resetKiosk}
                className="text-slate-500 bg-slate-100 px-3 py-2 rounded-xl text-xs md:text-sm font-bold flex items-center gap-2"
              >
                <CornerUpLeft size={16} /> Inicio
              </button>
            </div>
            <form onSubmit={handleFormSubmit} className="space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs md:text-sm font-bold text-slate-700 mb-1">
                    Cédula
                  </label>
                  <input
                    type="number"
                    name="cedula"
                    value={formData.cedula}
                    onChange={handleInputChange}
                    className="w-full p-2.5 md:p-3 border border-slate-300 rounded-xl bg-slate-100 font-bold"
                    required
                    readOnly={!!formData.cedula}
                  />
                </div>
                <div>
                  <label className="block text-xs md:text-sm font-bold text-slate-700 mb-1">
                    Nombres *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="w-full p-2.5 md:p-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-teal-500 outline-none"
                    required
                  />
                </div>
                <div>
                  <label className="block text-xs md:text-sm font-bold text-slate-700 mb-1">
                    Apellidos
                  </label>
                  <input
                    type="text"
                    name="apellidos"
                    value={formData.apellidos}
                    onChange={handleInputChange}
                    className="w-full p-2.5 md:p-3 border border-slate-300 rounded-xl"
                  />
                </div>
                <div>
                  <label className="block text-xs md:text-sm font-bold text-slate-700 mb-1">
                    EPS
                  </label>
                  <select
                    name="eps"
                    value={formData.eps}
                    onChange={handleInputChange}
                    className="w-full p-2.5 md:p-3 border border-slate-300 rounded-xl bg-white"
                  >
                    <option value="Particular">Particular</option>
                    {[...epsList].map((e) => (
                      <option key={e.id} value={e.name}>
                        {e.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 bg-teal-50/50 p-4 md:p-6 rounded-2xl border border-teal-100 mt-4 shadow-sm">
                <div>
                  <label className="block text-xs md:text-sm font-bold text-teal-800 mb-2">
                    Área *
                  </label>
                  <select
                    name="serviceId"
                    value={formData.serviceId}
                    onChange={handleInputChange}
                    className="w-full p-2.5 md:p-3 border border-teal-300 rounded-xl bg-white"
                    required
                  >
                    <option value="">-- Seleccionar --</option>
                    {sedeServices.map((s) => (
                      <option key={s.id} value={s.id}>
                        {s.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-xs md:text-sm font-bold text-teal-800 mb-2">
                    Médico (Opcional)
                  </label>
                  <select
                    name="staffId"
                    value={formData.staffId}
                    onChange={handleInputChange}
                    disabled={!formData.serviceId}
                    className="w-full p-2.5 md:p-3 border border-teal-300 rounded-xl disabled:opacity-50 bg-white"
                  >
                    <option value="">Cualquiera</option>
                    {staffList
                      .filter((s) => s.serviceId === formData.serviceId)
                      .map((staff) => (
                        <option key={staff.id} value={staff.id}>
                          {staff.name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="flex justify-end pt-4">
                <button
                  type="submit"
                  disabled={isProcessing}
                  className="w-full sm:w-auto px-8 py-3 md:py-4 text-base md:text-lg font-bold text-white bg-teal-600 rounded-xl shadow-lg hover:bg-teal-700 flex justify-center gap-2"
                >
                  {isProcessing ? (
                    <Loader2 className="animate-spin" />
                  ) : (
                    "Generar Turno"
                  )}
                </button>
              </div>
            </form>
          </div>
        )}

        {kioskPhase === "ticket" && generatedTicket && (
          <div className="w-full max-w-sm print:max-w-xs animate-pop-in">
            <div className="bg-white p-6 md:p-10 print:p-4 rounded-3xl print:rounded-none shadow-2xl print:shadow-none border-t-8 border-t-teal-500 print:border-t-0 print:border-2 print:border-black text-center mb-6 print:mb-0">
              <h2 className="text-lg md:text-xl print:text-sm font-bold text-slate-500 print:text-black mb-2">
                TURNO
              </h2>
              <div className="text-5xl md:text-6xl print:text-5xl font-black text-slate-800 print:text-black my-4 md:my-6 py-4 md:py-6 border-y-2 border-dashed bg-slate-50 print:bg-white">
                {generatedTicket.number}
              </div>
              <p className="text-xl md:text-2xl print:text-lg font-black text-slate-700 print:text-black mb-1 truncate">
                {generatedTicket.name}
              </p>
              <div className="text-sm md:text-md print:text-sm text-slate-500 print:text-black mb-4 md:mb-6 font-medium">
                {generatedTicket.serviceName}
                {generatedTicket.staffName && (
                  <span className="block mt-1 text-indigo-700 print:text-black truncate">
                    {generatedTicket.staffName}
                  </span>
                )}
              </div>
              <div className="bg-slate-800 print:bg-transparent text-white print:text-black text-lg md:text-xl font-black py-3 md:py-4 rounded-xl print:rounded-none">
                PISO {generatedTicket.floor}
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 print:hidden">
              <button
                onClick={() => window.print()}
                className="w-full bg-slate-800 text-white py-3 rounded-xl font-bold flex justify-center items-center gap-2 shadow-lg"
              >
                <Printer size={18} /> Imprimir
              </button>
              <button
                onClick={resetKiosk}
                className="w-full bg-teal-600 text-white py-3 rounded-xl font-bold flex justify-center items-center shadow-lg"
              >
                Finalizar
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ============================================================================
// MÓDULO: ORIENTADOR
// ============================================================================
function OrientadorView({
  sedes,
  services,
  rooms,
  tickets,
  updateTicketStatus,
  staffList,
  saveTicket,
  counters,
  updateCounter,
  showToast,
}) {
  const todayStr = getLocalDateString();
  const [searchTerm, setSearchTerm] = useState("");
  const [actionModal, setActionModal] = useState({
    show: false,
    type: "",
    ticket: null,
  });
  const [actionData, setActionData] = useState({
    note: "",
    roomId: "",
    serviceId: "",
    staffId: "",
  });

  const filteredTickets = [...tickets]
    .filter(
      (t) =>
        t.dateString === todayStr &&
        (t.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.number.toLowerCase().includes(searchTerm.toLowerCase()))
    )
    .sort((a, b) => b.timestamp - a.timestamp);

  const recallPatient = async (ticketId) => {
    await updateTicketStatus(ticketId, { calledAt: Date.now() });
    showToast("Señal de Re-llamado enviada", "success");
  };

  const executeAction = async () => {
    const tId = actionModal.ticket.id;
    if (actionModal.type === "call") {
      await updateTicketStatus(tId, {
        status: "called",
        roomId: actionData.roomId,
        calledAt: Date.now(),
      });
      showToast(`Paciente llamado`);
    } else if (actionModal.type === "finish" || actionModal.type === "absent") {
      await updateTicketStatus(tId, {
        status: actionModal.type,
        finishedAt: Date.now(),
        staffNote: actionData.note,
      });
      showToast("Estado actualizado");
    } else if (actionModal.type === "transfer") {
      await updateTicketStatus(tId, {
        status: "transferred",
        finishedAt: Date.now(),
        staffNote: actionData.note,
      });
      const destService = services.find((s) => s.id === actionData.serviceId);
      if (destService) {
        const nextCount = (counters[destService.id] || 0) + 1;
        const newTicket = {
          ...actionModal.ticket,
          id: Date.now().toString(),
          number: `${destService.prefix}-${nextCount
            .toString()
            .padStart(3, "0")}`,
          serviceId: destService.id,
          serviceName: destService.name,
          status: "waiting",
          timestamp: Date.now(),
          staffNote: actionData.note
            ? `[Traslado] ${actionData.note}`
            : "[Traslado]",
        };
        await saveTicket(newTicket);
        await updateCounter(destService.id, nextCount);
        showToast("Paciente trasladado");
      }
    }
    setActionModal({ show: false, type: "", ticket: null });
  };

  return (
    <div className="p-4 md:p-6 max-w-7xl mx-auto h-full flex flex-col relative print:hidden">
      {actionModal.show && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
          <div className="bg-white rounded-3xl w-full max-w-lg animate-pop-in border border-slate-200 overflow-hidden">
            <div className="p-4 md:p-5 text-white bg-slate-800">
              <h2 className="text-lg md:text-xl font-bold">
                Acción de Soporte
              </h2>
            </div>
            <div className="p-4 md:p-6 space-y-4">
              {actionModal.type === "call" && (
                <div>
                  <label className="block text-sm font-bold text-indigo-800 mb-2">
                    Espacio de Destino *
                  </label>
                  <select
                    value={actionData.roomId}
                    onChange={(e) =>
                      setActionData({ ...actionData, roomId: e.target.value })
                    }
                    className="w-full p-3 border border-indigo-200 rounded-xl"
                    required
                  >
                    <option value="">-- Seleccionar --</option>
                    {rooms
                      .filter(
                        (r) => r.serviceId === actionModal.ticket.serviceId
                      )
                      .map((r) => (
                        <option key={r.id} value={r.name}>
                          {r.name}
                        </option>
                      ))}
                  </select>
                </div>
              )}
              {actionModal.type === "transfer" && (
                <div>
                  <label className="block text-sm font-bold mb-2">
                    Nueva Área *
                  </label>
                  <select
                    value={actionData.serviceId}
                    onChange={(e) =>
                      setActionData({
                        ...actionData,
                        serviceId: e.target.value,
                      })
                    }
                    className="w-full p-3 border rounded-xl mb-3"
                    required
                  >
                    <option value="">-- Seleccionar --</option>
                    {services.map((s) => (
                      <option key={s.id} value={s.id}>
                        {s.name}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              <textarea
                value={actionData.note}
                onChange={(e) =>
                  setActionData({ ...actionData, note: e.target.value })
                }
                placeholder="Nota de orientación (Opcional)"
                className="w-full p-3 border rounded-xl"
              />
            </div>
            <div className="p-4 bg-slate-50 flex flex-col sm:flex-row gap-3">
              <button
                onClick={() =>
                  setActionModal({ show: false, type: "", ticket: null })
                }
                className="w-full py-3 bg-white font-bold rounded-xl shadow-sm border border-slate-200"
              >
                Cancelar
              </button>
              <button
                onClick={executeAction}
                className="w-full py-3 bg-slate-800 text-white font-bold rounded-xl"
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="bg-white p-4 md:p-6 rounded-2xl shadow-sm border border-slate-200 mb-4 md:mb-6 flex flex-col sm:flex-row gap-4 justify-between items-start sm:items-center">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-slate-800 flex items-center gap-2">
            <UserCog className="text-amber-500" /> Orientador
          </h2>
        </div>
        <div className="relative w-full sm:w-auto sm:min-w-[300px]">
          <Search className="absolute left-3 top-3 text-slate-400" size={20} />
          <input
            type="text"
            placeholder="Buscar paciente o turno..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 p-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-amber-500 outline-none text-sm"
          />
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 flex-1 overflow-hidden flex flex-col">
        <div className="overflow-y-auto p-2 md:p-4">
          <div className="grid gap-3">
            {filteredTickets.map((t) => (
              <div
                key={t.id}
                className={`p-3 md:p-4 border rounded-2xl flex flex-col lg:flex-row items-start lg:items-center justify-between gap-3 md:gap-4 transition-all ${
                  t.status === "called"
                    ? "bg-indigo-50/50 border-indigo-100"
                    : t.status === "paused"
                    ? "bg-yellow-50/50 border-yellow-200"
                    : "bg-slate-50 border-slate-200"
                } ${
                  ["finished", "absent"].includes(t.status) ? "opacity-60" : ""
                }`}
              >
                <div className="flex items-center gap-3 md:gap-4 w-full lg:w-auto">
                  <div className="text-xl md:text-3xl font-black w-20 md:w-24 text-center bg-white py-2 rounded-xl shadow-sm border border-slate-200 shrink-0">
                    {t.number}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-bold text-base md:text-xl text-slate-800 truncate">
                      {t.name}
                    </div>
                    <div className="text-xs md:text-sm text-slate-500 truncate">
                      {t.serviceName} • Piso {t.floor} •{" "}
                      <strong
                        className={`uppercase ${
                          t.status === "called"
                            ? "text-indigo-600"
                            : t.status === "paused"
                            ? "text-yellow-600"
                            : ""
                        }`}
                      >
                        {t.status}
                      </strong>
                    </div>
                  </div>
                </div>
                <div className="flex flex-wrap gap-2 w-full lg:w-auto justify-end border-t lg:border-t-0 pt-2 lg:pt-0 border-slate-200">
                  {["waiting", "paused"].includes(t.status) && (
                    <>
                      <button
                        onClick={() =>
                          setActionModal({
                            show: true,
                            type: "call",
                            ticket: t,
                          })
                        }
                        className="flex-1 lg:flex-none px-3 py-2 bg-indigo-100 text-indigo-700 font-bold rounded-lg text-xs md:text-sm text-center"
                      >
                        Llamar
                      </button>
                      <button
                        onClick={() =>
                          setActionModal({
                            show: true,
                            type: "transfer",
                            ticket: t,
                          })
                        }
                        className="flex-1 lg:flex-none px-3 py-2 bg-blue-50 text-blue-700 font-bold rounded-lg text-xs md:text-sm text-center"
                      >
                        Trasladar
                      </button>
                    </>
                  )}
                  {t.status === "called" && (
                    <>
                      <button
                        onClick={() => recallPatient(t.id)}
                        className="flex-1 lg:flex-none px-3 py-2 bg-amber-100 text-amber-700 font-bold rounded-lg text-xs md:text-sm text-center"
                      >
                        Re-llamar
                      </button>
                      <button
                        onClick={() =>
                          setActionModal({
                            show: true,
                            type: "transfer",
                            ticket: t,
                          })
                        }
                        className="flex-1 lg:flex-none px-3 py-2 bg-blue-50 text-blue-700 font-bold rounded-lg text-xs md:text-sm text-center"
                      >
                        Trasladar
                      </button>
                      <button
                        onClick={() =>
                          setActionModal({
                            show: true,
                            type: "finish",
                            ticket: t,
                          })
                        }
                        className="w-full lg:w-auto px-4 py-2 bg-green-600 text-white font-bold rounded-lg text-xs md:text-sm text-center mt-1 lg:mt-0"
                      >
                        Finalizar
                      </button>
                    </>
                  )}
                </div>
              </div>
            ))}
            {filteredTickets.length === 0 && (
              <div className="text-center p-8 text-slate-400 text-sm">
                No hay pacientes que coincidan con la búsqueda.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

// ============================================================================
// MÓDULO: ATENCIÓN STAFF
// ============================================================================
function StaffView({
  sedes,
  services,
  rooms,
  tickets,
  updateTicketStatus,
  staffList,
  saveTicket,
  updateCounter,
  counters,
  showToast,
}) {
  const [selectedSedeId, setSelectedSedeId] = useState(
    localStorage.getItem("dt_staff_sede") || ""
  );
  const [selectedServiceId, setSelectedServiceId] = useState(
    localStorage.getItem("dt_staff_service") || ""
  );
  const [selectedRoomName, setSelectedRoomName] = useState(
    localStorage.getItem("dt_staff_room") || ""
  );
  const [selectedStaffId, setSelectedStaffId] = useState(
    localStorage.getItem("dt_staff_staff") || ""
  );
  const [actionModal, setActionModal] = useState({
    show: false,
    type: "",
    ticket: null,
  });
  const [actionNote, setActionNote] = useState("");
  const [transferServiceId, setTransferServiceId] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const changeSede = (val) => {
    setSelectedSedeId(val);
    setSelectedServiceId("");
    setSelectedRoomName("");
    localStorage.setItem("dt_staff_sede", val);
    localStorage.removeItem("dt_staff_service");
    localStorage.removeItem("dt_staff_room");
  };
  const changeService = (val) => {
    setSelectedServiceId(val);
    localStorage.setItem("dt_staff_service", val);
    setSelectedRoomName("");
    localStorage.removeItem("dt_staff_room");
  };

  const todayStr = getLocalDateString();
  const waitingQueue = [...tickets]
    .filter(
      (t) =>
        t.dateString === todayStr &&
        t.serviceId === selectedServiceId &&
        t.status === "waiting"
    )
    .filter(
      (t) => !selectedStaffId || !t.staffId || t.staffId === selectedStaffId
    )
    .sort((a, b) => {
      if (a.priority && !b.priority) return -1;
      if (!a.priority && b.priority) return 1;
      return a.timestamp - b.timestamp;
    });
  const calledQueue = [...tickets]
    .filter(
      (t) =>
        t.dateString === todayStr &&
        t.serviceId === selectedServiceId &&
        t.status === "called" &&
        t.roomId === selectedRoomName
    )
    .sort((a, b) => b.calledAt - a.calledAt);
  const pausedQueue = [...tickets]
    .filter(
      (t) =>
        t.dateString === todayStr &&
        t.serviceId === selectedServiceId &&
        t.status === "paused"
    )
    .filter(
      (t) => !selectedStaffId || t.staffId === selectedStaffId || !t.staffId
    );
  const recentlyFinished = [...tickets]
    .filter(
      (t) =>
        t.dateString === todayStr &&
        ["finished", "absent", "transferred"].includes(t.status)
    )
    .filter(
      (t) => t.serviceId === selectedServiceId && t.roomId === selectedRoomName
    )
    .sort((a, b) => b.finishedAt - a.finishedAt)
    .slice(0, 5);

  const callNextPatient = async () => {
    if (!selectedServiceId || !selectedRoomName || waitingQueue.length === 0)
      return;
    const nextPatient = waitingQueue[0];
    await updateTicketStatus(nextPatient.id, {
      status: "called",
      roomId: selectedRoomName,
      calledAt: Date.now(),
    });
    showToast(`Llamado exitoso`);
  };
  const executeAction = async () => {
    const tId = actionModal.ticket.id;
    if (actionModal.type === "finish" || actionModal.type === "absent") {
      await updateTicketStatus(tId, {
        status: actionModal.type,
        finishedAt: Date.now(),
        staffNote: actionNote,
      });
      showToast("Atención finalizada");
    } else if (actionModal.type === "transfer") {
      await updateTicketStatus(tId, {
        status: "transferred",
        finishedAt: Date.now(),
        staffNote: actionNote,
      });
      const destService = services.find((s) => s.id === transferServiceId);
      if (destService) {
        const nextCount = (counters[destService.id] || 0) + 1;
        const newTicket = {
          ...actionModal.ticket,
          id: Date.now().toString(),
          number: `${destService.prefix}-${nextCount
            .toString()
            .padStart(3, "0")}`,
          serviceId: destService.id,
          serviceName: destService.name,
          status: "waiting",
          timestamp: Date.now(),
          staffNote: actionNote ? `[Nota previa] ${actionNote}` : "",
        };
        await saveTicket(newTicket);
        await updateCounter(destService.id, nextCount);
        showToast("Turno de traslado generado");
      }
    }
    setActionModal({ show: false, type: "", ticket: null });
  };

  return (
    <div className="p-2 md:p-6 max-w-6xl mx-auto h-full flex flex-col print:hidden relative">
      {actionModal.show && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
          <div className="bg-white rounded-3xl shadow-2xl w-full max-w-lg overflow-hidden animate-pop-in">
            <div className="p-4 md:p-5 text-white bg-slate-800">
              <h2 className="text-lg md:text-xl font-bold">Confirmar Acción</h2>
            </div>
            <div className="p-4 md:p-6 space-y-4">
              <div className="text-lg md:text-xl font-black truncate">
                {actionModal.ticket.number} - {actionModal.ticket.name}
              </div>
              {actionModal.type === "transfer" && (
                <div>
                  <label className="block text-sm font-bold text-blue-800 mb-1">
                    Nueva Área *
                  </label>
                  <select
                    value={transferServiceId}
                    onChange={(e) => setTransferServiceId(e.target.value)}
                    className="w-full p-3 border rounded-xl"
                    required
                  >
                    <option value="">-- Seleccionar --</option>
                    {services.map((s) => (
                      <option key={s.id} value={s.id}>
                        {s.name}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              <textarea
                value={actionNote}
                onChange={(e) => setActionNote(e.target.value)}
                placeholder="Nota Clínica (Opcional)"
                className="w-full p-3 border rounded-xl h-24 text-sm"
              />
            </div>
            <div className="p-4 bg-slate-50 flex flex-col sm:flex-row gap-3">
              <button
                onClick={() =>
                  setActionModal({ show: false, type: "", ticket: null })
                }
                className="w-full py-3 bg-white border font-bold rounded-xl shadow-sm text-sm"
              >
                Cancelar
              </button>
              <button
                onClick={executeAction}
                disabled={actionModal.type === "transfer" && !transferServiceId}
                className="w-full py-3 bg-slate-800 text-white font-bold rounded-xl text-sm disabled:opacity-50"
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Selector Móvil Collapse */}
      <div className="md:hidden bg-white rounded-xl shadow-sm border border-slate-200 mb-4 overflow-hidden">
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className="w-full p-4 flex justify-between items-center font-bold text-slate-700 bg-slate-50"
        >
          <span>Configuración del Consultorio</span>
          <ChevronRight
            className={`transition-transform ${
              isSidebarOpen ? "rotate-90" : ""
            }`}
            size={20}
          />
        </button>
        {isSidebarOpen && (
          <div className="p-4 grid grid-cols-1 gap-3 border-t border-slate-200">
            <select
              value={selectedSedeId}
              onChange={(e) => changeSede(e.target.value)}
              className="w-full p-2.5 border rounded-lg bg-slate-50 text-sm"
            >
              <option value="">Sede...</option>
              {sedes.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
            </select>
            <select
              value={selectedServiceId}
              onChange={(e) => changeService(e.target.value)}
              disabled={!selectedSedeId}
              className="w-full p-2.5 border rounded-lg bg-slate-50 text-sm"
            >
              <option value="">Área...</option>
              {services
                .filter((s) => s.sedeId === selectedSedeId)
                .map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name}
                  </option>
                ))}
            </select>
            <select
              value={selectedRoomName}
              onChange={(e) => {
                setSelectedRoomName(e.target.value);
                localStorage.setItem("dt_staff_room", e.target.value);
              }}
              disabled={!selectedServiceId}
              className="w-full p-2.5 border rounded-lg bg-slate-50 text-sm"
            >
              <option value="">Mi Espacio...</option>
              {rooms
                .filter((r) => r.serviceId === selectedServiceId)
                .map((r) => (
                  <option key={r.id} value={r.name}>
                    {r.name}
                  </option>
                ))}
            </select>
            <select
              value={selectedStaffId}
              onChange={(e) => {
                setSelectedStaffId(e.target.value);
                localStorage.setItem("dt_staff_staff", e.target.value);
              }}
              disabled={!selectedServiceId}
              className="w-full p-2.5 border border-indigo-300 rounded-lg bg-indigo-50 text-sm"
            >
              <option value="">Todos los Profesionales</option>
              {staffList
                .filter((s) => s.serviceId === selectedServiceId)
                .map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name}
                  </option>
                ))}
            </select>
          </div>
        )}
      </div>

      {/* Selector Desktop */}
      <div className="hidden md:grid bg-white p-6 rounded-2xl shadow-sm border border-slate-200 mb-6 grid-cols-4 gap-4">
        <div>
          <label className="block text-xs font-bold text-slate-500 uppercase mb-1">
            1. Ubicación
          </label>
          <select
            value={selectedSedeId}
            onChange={(e) => changeSede(e.target.value)}
            className="w-full p-3 border rounded-xl bg-slate-50 text-sm"
          >
            <option value="">-- Seleccionar --</option>
            {sedes.map((s) => (
              <option key={s.id} value={s.id}>
                {s.name}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-xs font-bold text-slate-500 uppercase mb-1">
            2. Área
          </label>
          <select
            value={selectedServiceId}
            onChange={(e) => changeService(e.target.value)}
            disabled={!selectedSedeId}
            className="w-full p-3 border rounded-xl bg-slate-50 text-sm"
          >
            <option value="">-- Seleccionar --</option>
            {services
              .filter((s) => s.sedeId === selectedSedeId)
              .map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
          </select>
        </div>
        <div>
          <label className="block text-xs font-bold text-slate-500 uppercase mb-1">
            3. Mi Espacio
          </label>
          <select
            value={selectedRoomName}
            onChange={(e) => {
              setSelectedRoomName(e.target.value);
              localStorage.setItem("dt_staff_room", e.target.value);
            }}
            disabled={!selectedServiceId}
            className="w-full p-3 border rounded-xl bg-slate-50 text-sm"
          >
            <option value="">-- Seleccionar --</option>
            {rooms
              .filter((r) => r.serviceId === selectedServiceId)
              .map((r) => (
                <option key={r.id} value={r.name}>
                  {r.name}
                </option>
              ))}
          </select>
        </div>
        <div>
          <label className="block text-xs font-bold text-indigo-500 uppercase mb-1">
            4. Profesional
          </label>
          <select
            value={selectedStaffId}
            onChange={(e) => {
              setSelectedStaffId(e.target.value);
              localStorage.setItem("dt_staff_staff", e.target.value);
            }}
            disabled={!selectedServiceId}
            className="w-full p-3 border border-indigo-300 rounded-xl bg-indigo-50 text-sm"
          >
            <option value="">(Todos)</option>
            {staffList
              .filter((s) => s.serviceId === selectedServiceId)
              .map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
          </select>
        </div>
      </div>

      <div className="flex-1 flex flex-col lg:flex-row gap-4 md:gap-6 min-h-0">
        <div className="w-full lg:w-1/3 bg-indigo-50/50 rounded-2xl p-4 md:p-6 border border-indigo-100 flex flex-col items-center justify-center relative shrink-0">
          <div className="text-center mb-4 md:mb-6">
            <h3 className="text-xl md:text-2xl font-bold text-slate-600 mb-1">
              Fila de Espera
            </h3>
            <div className="text-6xl md:text-7xl font-black text-indigo-600">
              {waitingQueue.length}
            </div>
          </div>
          {waitingQueue.length > 0 && (
            <div className="w-full bg-white/60 p-3 md:p-4 rounded-xl border border-indigo-100 mb-4 md:mb-6 text-left">
              <h4 className="text-xs font-bold text-indigo-500 mb-2 uppercase flex items-center gap-1">
                <ListOrdered size={14} /> Próximos
              </h4>
              <div className="space-y-2">
                {waitingQueue.slice(0, 3).map((t, index) => (
                  <div
                    key={t.id}
                    className={`flex flex-col p-2 rounded-lg ${
                      index === 0
                        ? "bg-indigo-100/50 border border-indigo-200"
                        : "bg-white/50"
                    }`}
                  >
                    <span className="font-bold text-sm md:text-base">
                      {t.number}{" "}
                      {t.priority && (
                        <Star
                          size={10}
                          className="inline fill-amber-500 text-amber-500"
                        />
                      )}
                    </span>
                    <span className="text-xs text-slate-500 truncate">
                      {t.name}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
          <button
            onClick={callNextPatient}
            disabled={
              !selectedServiceId ||
              !selectedRoomName ||
              waitingQueue.length === 0
            }
            className={`w-full py-4 md:py-5 rounded-2xl text-lg md:text-xl font-black shadow-lg flex items-center justify-center gap-2 md:gap-3 transition-all mt-auto ${
              !selectedServiceId ||
              !selectedRoomName ||
              waitingQueue.length === 0
                ? "bg-slate-200 text-slate-400 cursor-not-allowed"
                : "bg-indigo-600 text-white hover:bg-indigo-700 active:scale-95"
            }`}
          >
            <Volume1 size={24} className="shrink-0" /> LLAMAR
          </button>
        </div>

        <div className="flex-1 bg-white rounded-2xl p-4 md:p-6 shadow-sm border border-slate-200 flex flex-col overflow-y-auto">
          <h3 className="text-base md:text-lg font-bold text-slate-800 mb-3 md:mb-4 border-b pb-2 md:pb-3">
            En Atención
          </h3>
          <div className="space-y-3 md:space-y-4">
            {calledQueue.map((t) => (
              <div
                key={t.id}
                className="p-4 border border-indigo-100 rounded-2xl bg-indigo-50/30 flex flex-col sm:flex-row justify-between gap-3 shadow-sm"
              >
                <div className="flex flex-col sm:flex-row gap-3 sm:items-center">
                  <div className="bg-white px-3 py-1.5 md:py-2 border rounded-xl font-black text-xl md:text-2xl w-full sm:w-24 text-center shrink-0">
                    {t.number}
                  </div>
                  <div className="font-bold text-base md:text-lg break-words">
                    {t.name}
                  </div>
                </div>
                <div className="grid grid-cols-4 sm:flex gap-2 justify-end mt-2 sm:mt-0">
                  <button
                    onClick={() => {
                      updateTicketStatus(t.id, { calledAt: Date.now() });
                      showToast("Re-llamado");
                    }}
                    className="p-2 md:p-3 bg-white border rounded-xl text-indigo-600 hover:bg-indigo-50 flex justify-center"
                  >
                    <RefreshCw size={18} />
                  </button>
                  <button
                    onClick={() => {
                      updateTicketStatus(t.id, {
                        status: "paused",
                        roomId: null,
                      });
                      showToast("Pausado");
                    }}
                    className="p-2 md:p-3 bg-yellow-50 border rounded-xl text-yellow-700 hover:bg-yellow-100 flex justify-center"
                  >
                    <PauseCircle size={18} />
                  </button>
                  <button
                    onClick={() =>
                      setActionModal({
                        show: true,
                        type: "transfer",
                        ticket: t,
                      })
                    }
                    className="p-2 md:p-3 bg-blue-50 border rounded-xl text-blue-700 hover:bg-blue-100 flex justify-center"
                  >
                    <CornerUpLeft size={18} />
                  </button>
                  <button
                    onClick={() =>
                      setActionModal({ show: true, type: "finish", ticket: t })
                    }
                    className="p-2 md:px-4 md:py-3 bg-green-600 rounded-xl text-white hover:bg-green-700 shadow-md flex justify-center items-center"
                  >
                    <Check size={18} className="sm:hidden" />
                    <span className="hidden sm:inline font-bold text-sm">
                      Finalizar
                    </span>
                  </button>
                </div>
              </div>
            ))}
            {calledQueue.length === 0 && (
              <div className="text-center pt-4 md:pt-6 text-slate-400">
                <DoorOpen size={36} className="mx-auto mb-2 opacity-30" />
                <p className="text-sm md:text-md">Sin pacientes en consulta.</p>
              </div>
            )}
          </div>

          {pausedQueue.length > 0 && (
            <div className="mt-4 md:mt-6 border-t pt-3 md:pt-4">
              <h3 className="text-xs md:text-sm font-bold text-yellow-600 mb-2 md:mb-3 flex items-center gap-1">
                <PauseCircle size={14} /> En Examen (Pausados)
              </h3>
              {pausedQueue.map((t) => (
                <div
                  key={t.id}
                  className="flex flex-col sm:flex-row justify-between p-2 md:p-3 bg-yellow-50/50 border border-yellow-200 rounded-xl text-sm mb-2 gap-2"
                >
                  <div className="flex items-center gap-2">
                    <span className="font-bold text-yellow-700 bg-yellow-100 px-2 py-1 rounded text-xs">
                      {t.number}
                    </span>
                    <span className="truncate max-w-[200px]">{t.name}</span>
                  </div>
                  <button
                    onClick={() => {
                      updateTicketStatus(t.id, {
                        status: "called",
                        roomId: selectedRoomName,
                        calledAt: Date.now(),
                      });
                      showToast("Reanudado");
                    }}
                    className="w-full sm:w-auto bg-yellow-500 text-white hover:bg-yellow-600 font-bold px-3 py-1.5 rounded flex items-center justify-center gap-1 text-xs md:text-sm"
                  >
                    <PlayCircle size={14} /> Reanudar
                  </button>
                </div>
              ))}
            </div>
          )}

          {recentlyFinished.length > 0 && (
            <div className="mt-auto border-t pt-3 md:pt-4">
              <h3 className="text-xs font-bold text-slate-400 mb-2">
                Atendidos Recientemente
              </h3>
              {recentlyFinished.map((t) => (
                <div
                  key={t.id}
                  className="flex justify-between items-center p-1.5 md:p-2 bg-slate-50 rounded-lg text-xs md:text-sm mb-1"
                >
                  <span className={`font-bold w-12 md:w-16`}>{t.number}</span>
                  <button
                    onClick={() => {
                      updateTicketStatus(t.id, {
                        status: "waiting",
                        finishedAt: null,
                        roomId: null,
                      });
                      showToast("Deshecho");
                    }}
                    className="text-slate-400 hover:text-indigo-600 flex items-center gap-1 bg-white px-2 py-1 rounded border shadow-sm"
                  >
                    <CornerUpLeft size={12} /> Deshacer
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ============================================================================
// MÓDULO: PANTALLA TV
// ============================================================================
function DisplayView({ sedes, tickets, globalSettings }) {
  const [displaySedeId, setDisplaySedeId] = useState("");
  const [displayFloor, setDisplayFloor] = useState("ALL");
  const displayRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [audioUnlocked, setAudioUnlocked] = useState(false);

  const [showBigAlert, setShowBigAlert] = useState(false);

  useEffect(() => {
    if (sedes.length > 0 && !displaySedeId) setDisplaySedeId(sedes[0].id);
  }, [sedes, displaySedeId]);

  const todayStr = getLocalDateString();

  const allCalledTickets = [...tickets]
    .filter(
      (t) =>
        t.dateString === todayStr &&
        t.calledAt != null &&
        t.sedeId === displaySedeId &&
        (displayFloor === "ALL" || t.floor === displayFloor.toString())
    )
    .sort((a, b) => b.calledAt - a.calledAt);

  const latestCall = allCalledTickets.length > 0 ? allCalledTickets[0] : null;
  const history = allCalledTickets.slice(1, 6);

  const previousCallTimeRef = useRef(null);

  const getEmbedUrl = (url) => {
    if (!url) return null;
    let videoId = "";
    if (url.includes("youtube.com/watch?v="))
      videoId = url.split("v=")[1].split("&")[0];
    else if (url.includes("youtu.be/"))
      videoId = url.split("youtu.be/")[1].split("?")[0];
    else if (url.includes("youtube.com/embed/"))
      return url.includes("autoplay=1")
        ? url
        : url +
            (url.includes("?") ? "&autoplay=1&mute=1" : "?autoplay=1&mute=1");

    return videoId
      ? `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0`
      : url;
  };

  useEffect(() => {
    if (latestCall && audioUnlocked) {
      if (
        !previousCallTimeRef.current ||
        previousCallTimeRef.current !== latestCall.calledAt
      ) {
        previousCallTimeRef.current = latestCall.calledAt;

        setShowBigAlert(true);

        if (globalSettings.volume > 0 && "speechSynthesis" in window) {
          window.speechSynthesis.cancel();
          const textToSpeak = `Atención turno ${latestCall.number.replace(
            "-",
            " "
          )}, por favor pasar a ${latestCall.roomId}`;
          const utterance = new SpeechSynthesisUtterance(textToSpeak);
          utterance.lang = "es-ES";
          utterance.rate = 0.85;
          utterance.volume = globalSettings.volume;
          const ding = new SpeechSynthesisUtterance("Ding dong.");
          ding.lang = "es-ES";
          ding.rate = 1.5;
          ding.volume = globalSettings.volume;
          window.speechSynthesis.speak(ding);
          window.speechSynthesis.speak(utterance);
        }

        const timer = setTimeout(() => {
          setShowBigAlert(false);
        }, 12000);

        return () => clearTimeout(timer);
      }
    }
  }, [latestCall, globalSettings.volume, displayFloor, audioUnlocked]);

  const toggleFullscreen = () => {
    if (isFullscreen) {
      if (document.fullscreenElement) document.exitFullscreen().catch((e) => e);
      setIsFullscreen(false);
    } else {
      if (displayRef.current.requestFullscreen) {
        displayRef.current
          .requestFullscreen()
          .then(() => setIsFullscreen(true))
          .catch(() => setIsFullscreen(true));
      } else {
        setIsFullscreen(true);
      }
    }
  };

  useEffect(() => {
    const hFC = () => {
      if (!document.fullscreenElement) setIsFullscreen(false);
    };
    document.addEventListener("fullscreenchange", hFC);
    return () => document.removeEventListener("fullscreenchange", hFC);
  }, []);

  useEffect(() => {
    const hKD = (e) => {
      if (e.key === "Escape") setIsFullscreen(false);
    };
    window.addEventListener("keydown", hKD);
    return () => window.removeEventListener("keydown", hKD);
  }, []);

  if (!audioUnlocked) {
    return (
      <div className="h-full flex flex-col items-center justify-center bg-slate-900 text-white print:hidden p-4 text-center">
        <MonitorPlay
          size={64}
          className="text-teal-500 mb-6 opacity-80 md:w-20 md:h-20"
        />
        <h2 className="text-2xl md:text-3xl font-bold mb-6 md:mb-8">
          Pantalla de Llamados (TV)
        </h2>
        <button
          onClick={() => {
            setAudioUnlocked(true);
            if ("speechSynthesis" in window) {
              const unlockAudio = new SpeechSynthesisUtterance("iniciando");
              unlockAudio.volume = 0.01;
              window.speechSynthesis.speak(unlockAudio);
            }
          }}
          className="bg-teal-600 hover:bg-teal-500 text-white px-6 py-4 md:px-10 md:py-5 rounded-2xl font-black text-xl md:text-2xl flex items-center gap-3 md:gap-4 shadow-xl shadow-teal-900/50"
        >
          <Play size={28} /> Iniciar Pantalla
        </button>
      </div>
    );
  }

  return (
    <div
      ref={displayRef}
      className={`bg-slate-900 flex flex-col overflow-hidden text-white print:hidden ${
        isFullscreen && !document.fullscreenElement
          ? "fixed inset-0 z-[9999] w-full h-full"
          : "h-full relative"
      }`}
    >
      <div className="absolute top-2 right-2 md:top-4 md:right-4 z-50 flex gap-2 transition-opacity duration-300 hover:opacity-100 opacity-0">
        <select
          value={displaySedeId}
          onChange={(e) => setDisplaySedeId(e.target.value)}
          className="bg-slate-800/90 text-white p-1.5 md:p-2 rounded-lg font-bold text-xs md:text-sm outline-none"
        >
          {sedes.map((s) => (
            <option key={s.id} value={s.id}>
              Sede: {s.name}
            </option>
          ))}
        </select>
        <button
          onClick={toggleFullscreen}
          className="bg-slate-800/90 hover:bg-teal-600 text-white p-1.5 md:p-2 rounded-lg"
        >
          {isFullscreen ? <Minimize size={16} /> : <Maximize size={16} />}
        </button>
      </div>

      <div className="bg-white p-2 md:p-3 border-b border-slate-800 flex justify-between items-center z-20 shadow-md">
        <div className="flex items-center gap-2 md:gap-6">
          {globalSettings.logoUrl ? (
            <img
              src={globalSettings.logoUrl}
              alt="Logo"
              className="h-8 md:h-14 object-contain"
            />
          ) : (
            <span className="text-slate-800 font-black text-lg md:text-2xl">
              Mi Clínica
            </span>
          )}
          <div className="hidden sm:block bg-slate-800 text-white px-3 md:px-5 py-1 md:py-1.5 rounded-full font-bold text-xs md:text-lg tracking-widest border border-slate-300 uppercase">
            {sedes.find((s) => s.id === displaySedeId)?.name}
          </div>
        </div>
        <div className="text-lg md:text-2xl font-mono text-slate-800 font-bold bg-slate-100 px-3 md:px-5 py-1 md:py-1.5 rounded-lg border border-slate-200">
          {new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </div>
      </div>

      <div className="flex-1 flex flex-col md:flex-row relative">
        <div className="flex-[2.5] relative bg-black flex flex-col justify-center items-center border-b md:border-b-0 md:border-r border-slate-700 overflow-hidden">
          {globalSettings.mediaUrl && (
            <iframe
              src={getEmbedUrl(globalSettings.mediaUrl)}
              className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${
                showBigAlert
                  ? "opacity-10 blur-sm scale-105"
                  : "opacity-100 scale-100"
              }`}
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              title="Video Institucional"
            ></iframe>
          )}

          {showBigAlert && latestCall && (
            <div className="z-10 w-[90%] max-w-4xl text-center bg-slate-900/90 backdrop-blur-xl p-8 md:p-16 rounded-[3rem] border-2 border-slate-600 shadow-[0_0_50px_rgba(0,0,0,0.5)] animate-pop-in">
              <div className="mb-2 md:mb-4 text-xl md:text-3xl font-bold tracking-widest text-slate-400 uppercase animate-pulse">
                TURNO ACTUAL
              </div>
              <div
                className={`text-[7rem] md:text-[12rem] leading-none font-black mb-4 md:mb-8 py-2 border-y-2 border-slate-700/50 ${
                  latestCall.priority ? "text-amber-400" : "text-white"
                }`}
              >
                {latestCall.number}
              </div>
              <div className="flex flex-col gap-4 text-left">
                <div className="bg-teal-900/60 p-5 md:p-8 rounded-2xl flex flex-col sm:flex-row sm:items-center justify-between border border-teal-500/30">
                  <div>
                    <div className="text-sm md:text-lg font-bold text-teal-400 mb-1 tracking-widest">
                      PASAR AL MÓDULO
                    </div>
                    <div className="text-3xl md:text-5xl lg:text-6xl font-black text-teal-300 uppercase break-words">
                      {latestCall.roomId}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {!globalSettings.mediaUrl && !showBigAlert && (
            <div className="text-center opacity-30 z-10">
              <MonitorPlay className="mx-auto text-slate-500 mb-4 w-16 h-16 md:w-32 md:h-32" />
              <h2 className="text-xl md:text-3xl font-bold text-slate-500">
                Esperando llamados...
              </h2>
            </div>
          )}
        </div>

        <div className="flex-[1] min-w-[300px] lg:min-w-[400px] bg-slate-950 flex flex-col z-20 shadow-2xl">
          <div className="bg-slate-900 border-b border-slate-800 p-6 flex flex-col">
            <h3 className="text-teal-500 font-black tracking-widest text-sm mb-2 flex items-center gap-2">
              <Volume2 size={18} /> ÚLTIMO LLAMADO
            </h3>
            {latestCall ? (
              <div className="bg-slate-800 border border-slate-700 rounded-2xl p-4 shadow-lg text-center transform transition-transform hover:scale-105">
                <div
                  className={`text-5xl lg:text-6xl font-black ${
                    latestCall.priority ? "text-amber-400" : "text-white"
                  }`}
                >
                  {latestCall.number}
                </div>
                <div className="text-lg text-slate-400 font-bold mt-1 truncate px-2">
                  {latestCall.name}
                </div>
                <div className="bg-teal-900/50 text-teal-300 font-black text-xl py-2 mt-3 rounded-xl border border-teal-800/50">
                  Módulo: {latestCall.roomId}
                </div>
              </div>
            ) : (
              <div className="h-32 flex items-center justify-center border-2 border-dashed border-slate-800 rounded-2xl text-slate-600 font-bold">
                Aún no hay llamados
              </div>
            )}
          </div>

          <div className="flex-1 flex flex-col min-h-0">
            <div className="px-6 py-4 bg-slate-950 sticky top-0 border-b border-slate-900 z-10">
              <h2 className="text-sm font-bold text-slate-500 tracking-widest flex items-center gap-2">
                <ListOrdered size={16} /> HISTORIAL PREVIO
              </h2>
            </div>
            <div className="flex-1 overflow-y-auto p-4 space-y-3">
              {history.map((t, idx) => (
                <div
                  key={`${t.id}-${t.calledAt}`}
                  className="bg-slate-900 p-4 rounded-2xl flex items-center gap-4 border border-slate-800/50"
                  style={{ opacity: 1 - idx * 0.15 }}
                >
                  <div
                    className={`text-2xl lg:text-3xl font-black w-24 text-center border-r border-slate-700 ${
                      t.priority ? "text-amber-500" : "text-slate-400"
                    }`}
                  >
                    {t.number}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-base lg:text-lg font-bold text-slate-300 truncate">
                      {t.name}
                    </div>
                    <div className="text-teal-500 font-bold text-sm flex items-center gap-1">
                      <ArrowRight size={14} /> {t.roomId}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="bg-teal-800 text-white p-2 md:p-3 whitespace-nowrap overflow-hidden z-20 shadow-[0_-4px_15px_rgba(0,0,0,0.3)]">
        <div className="animate-marquee text-sm md:text-xl font-medium tracking-wide">
          {globalSettings.tvMarquee}
        </div>
      </div>

      <style
        dangerouslySetInnerHTML={{
          __html: `@keyframes marquee { 0% { transform: translateX(100vw); } 100% { transform: translateX(-100%); } } .animate-marquee { animation: marquee 30s linear infinite; } @keyframes pop-in { 0% { transform: scale(0.9); opacity: 0; } 100% { transform: scale(1); opacity: 1; } } .animate-pop-in { animation: pop-in 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards; }`,
        }}
      />
    </div>
  );
}
